<template>
    <div class="rounded-lg" :class="{ 'entry-only-advanced': entryOnlyMode }" style="z-index: 200; min-height: 500px;">
        <block v-if="loading"></block>
        <v-stepper v-model="step" class="white pa-4">
            <v-stepper-header style="flex-wrap: nowrap;">
                <v-stepper-step v-if="!entryOnlyMode" :complete="step > 1" step="1">
                    Carga de datos
                </v-stepper-step>
                <v-stepper-step :complete="step > 2" step="2">
                    Verificación de datos
                </v-stepper-step>
                <v-stepper-step :complete="step > 3" step="3">
                    Configuración de cuentas
                </v-stepper-step>
                <v-stepper-step :complete="step > 4" step="4">
                    Partidas contables
                </v-stepper-step>
                <v-stepper-step v-if="!entryOnlyMode" :complete="step > 5" step="5">
                    Previsualización de datos
                </v-stepper-step>
                <v-stepper-step v-if="!entryOnlyMode" step="6">
                    Procesamiento de datos
                </v-stepper-step>
            </v-stepper-header>

            <div style="margin-top: 1rem; display: flex; flex-direction: row; justify-content: flex-end;">
                <!-- <v-btn class="btn-save" @click="downloadTemplate" :disabled="loading">
                    <v-icon class="mr-2">mdi-download</v-icon>Descargar plantilla para importar
                </v-btn> -->
                <v-btn v-if="entryOnlyMode" class="btnclean" @click="$emit('cancel')" :disabled="loading">
                    <v-icon class="mr-2">mdi-close</v-icon>Cerrar
                </v-btn>
                <v-btn v-else class="btnclean" @click="resetAll" :disabled="loading || !dataLoaded">
                    <v-icon class="mr-2">mdi-broom</v-icon>Reiniciar
                </v-btn>
            </div>

            <v-stepper-items>

                <!-- Step 1: Upload Json -->
                <v-stepper-content v-if="!entryOnlyMode" step="1">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-step">
                                <v-card-title class="font-weight-bold text-nowrap">Importar gastos desde archivos JSON</v-card-title>
                                <v-card-actions>
                                    <v-row style="margin-top: 1rem;">
                                        <v-col cols="12" md="6" xs="12">
                                            <div style="margin-bottom: 2rem;">
                                                <input
                                                    id="file-input-advanced"
                                                    style="display: none;"
                                                    type="file"
                                                    webkitdirectory
                                                    directory
                                                    multiple
                                                    @click="$event.target.value=''"
                                                    @change="handleFolderFiles($event)"
                                                    :disabled="loading || dataLoaded"
                                                />
                                                <label for="file-input-advanced" style="cursor: pointer; width: 100%; border: 1px solid grey; height: 40px; border-radius: 5px; display: flex; align-items: center; justify-content: center;">
                                                    Elegir directorio completo
                                                </label>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <div style="margin-bottom: 2rem;">
                                                <input
                                                    id="file-input-individual-advanced"
                                                    style="display: none;"
                                                    type="file"
                                                    multiple
                                                    accept=".json"
                                                    @click="$event.target.value=''"
                                                    @change="handleIndividualFiles($event)"
                                                    :disabled="loading || dataLoaded"
                                                />
                                                <label for="file-input-individual-advanced" style="cursor: pointer; width: 100%; border: 1px solid grey; height: 40px; border-radius: 5px; display: flex; align-items: center; justify-content: center; ">
                                                    Elegir varios archivos individualmente
                                                </label>
                                            </div>
                                        </v-col>

                                        <v-col cols="12">
                                            <div v-if="selectedFilesNames.length > 0" style="margin: 1rem 0;">
                                                <h4>Archivos seleccionados:</h4>
                                                <v-data-table
                                                    :headers="[{text: '', value: 'name'}]"
                                                    :items="selectedFilesNames"
                                                    :items-per-page="5"
                                                    :footer-props="{
                                                        showFirstLastPage: false,
                                                        'items-per-page-options': [],
                                                        'items-per-page-text':'Items por pagina:',
                                                    }"
                                                    class="file-table"
                                                >
                                                </v-data-table>
                                            </div>

                                            <!-- Sección de archivos inválidos -->
                                            <div v-if="invalidJsonFiles.length > 0" style="margin: 1rem 0;">
                                                <v-alert type="warning" dense outlined>
                                                    <h4 style="margin-bottom: 10px;">Archivos que no se procesarán ({{ invalidJsonFiles.length }}):</h4>
                                                    <v-simple-table dense>
                                                        <template v-slot:default>
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left">Archivo</th>
                                                                    <th class="text-left">Motivo</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(file, index) in invalidJsonFiles" :key="index">
                                                                    <td>{{ file.fileName }}</td>
                                                                    <td style="color: #e3191e;">{{ file.error }}</td>
                                                                </tr>
                                                            </tbody>
                                                        </template>
                                                    </v-simple-table>
                                                    <p style="margin-top: 10px; font-size: 14px;">
                                                        <strong>Nota:</strong> Los archivos válidos se procesarán normalmente.
                                                    </p>
                                                </v-alert>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-card-actions>
                                <v-card-actions style="padding: 1rem; justify-content: flex-end;">
                                    <v-btn v-if="!dataLoaded" class="btn-import" @click="duplicatedValidation" :disabled="loading">
                                        <v-icon class="mr-2">mdi-folder-upload</v-icon>Cargar archivos y continuar
                                    </v-btn>
                                    <v-btn v-else class="btncontinue" @click="nextStep" :disabled="loading">Continuar</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-stepper-content>

                <!-- Step 2: Verifying data -->
                <v-stepper-content step="2">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-step">
                                <v-card-title class="font-weight-bold text-nowrap">Datos de los archivos cargados</v-card-title>
                                <v-card-text v-if="errors" style="display: flex; flex-direction: row;">
                                    <v-icon color="red darken-4" style="margin: 10px; font-size: 20px;" >mdi-alert-circle</v-icon>
                                    <p style="margin-top: 20px; margin-bottom: 20px; font-size: 16px; color: #e3191e !important;">
                                        Algunos proveedores no se encuentran registrados, sus productos no serán procesados.
                                    </p>
                                </v-card-text>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" md="4">
                                            <v-checkbox v-model="selectAll" @click.prevent="switchSelectAll" label="Seleccionar todo"></v-checkbox>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" md="4">
                                            <v-checkbox v-model="percentageIvaCheck" label="Solo tomar % IVA"></v-checkbox>
                                        </v-col>
                                        <v-col cols="12" md="4" v-if="percentageIvaCheck">
                                            <v-text-field
                                                v-model="percentageIva"
                                                outlined
                                                dense
                                                label="Porcentaje de IVA"
                                            />
                                        </v-col>
                                    </v-row>
                                    <CustomCSVPeriod @customCSVPeriod="setCustomCSVPeriod" @year="setCustomCSVPeriodYear" @month="setCustomCSVPeriodMonth" :cleanState="cleanState" @resetCleanState="() => cleanState = false" :submitState="submitCustomCSVPeriodState" />

                                    <!-- Card de clasificación para anexos -->
                                    <v-card outlined class="mt-4">
                                        <v-card-title class="text-subtitle-1 font-weight-bold">
                                            Clasificación para anexos
                                        </v-card-title>
                                        <v-card-text>
                                            <v-row>

                                                <v-col cols="12" md="3">
                                                    <ClasificationRentaAutocomplete
                                                        v-model="globalClasificationRent"
                                                    />
                                                </v-col>
                                                <v-col cols="12" md="3">
                                                    <v-select
                                                        v-model="globalPaymentCondition"
                                                        :items="['Contado', 'Crédito']"
                                                        outlined
                                                        dense
                                                        label="Condición de Pago"
                                                    ></v-select>
                                                </v-col>
                                                <v-col cols="12" md="3">
                                                    <v-select
                                                        v-model="globalSectorProveedores"
                                                        :items="sectorProveedoresList"
                                                        item-text="Valores"
                                                        item-value="Codigo"
                                                        label="Sector Proveedores"
                                                        outlined
                                                        dense
                                                        clearable
                                                    ></v-select>
                                                </v-col>
                                                <v-col cols="12" md="3">
                                                    <v-select
                                                        v-model="globalTipoIngresoProveedores"
                                                        :items="tipoIngresoProveedoresList"
                                                        item-text="Valores"
                                                        item-value="Codigo"
                                                        label="Tipo Ingreso Proveedores"
                                                        outlined
                                                        dense
                                                        clearable
                                                    ></v-select>
                                                </v-col>
                                                <v-col cols="12" md="3" class="text-right">
                                                    <v-btn
                                                        color="primary"
                                                        @click="assignAllClassifications"
                                                        :disabled="!globalTipoIngresoProveedores && !globalSectorProveedores && !globalClasificationRent && !globalPaymentCondition"
                                                    >
                                                        <v-icon left>mdi-check-all</v-icon>
                                                        Asignar a todos
                                                    </v-btn>
                                                </v-col>
                                                <v-col>
                                                    <small>Los campos <b>Tipo de Costo / Gasto</b> y <b>Sector</b> son opcionales; si no se seleccionan, se tomarán los valores predeterminados del proveedor.</small>
                                                </v-col>
                                            </v-row>

                                        </v-card-text>
                                    </v-card>
                                </v-card-text>
                                <v-data-table
                                    ref="dataTableStep2"
                                    :headers="headers"
                                    :items="data"
                                    :items-per-page="50"
                                    :footer-props="{
                                        showFirstLastPage: true,
                                        firstIcon: 'mdi-page-first',
                                        lastIcon: 'mdi-page-last',
                                        'items-per-page-options': [50, 100, 250],
                                        'items-per-page-text':'Items por pagina:',
                                    }"
                                    class="data-table"
                                >
                                    <template v-slot:item.status="{ item }">
                                        <v-icon v-if="item.error" color="red darken-4" style="margin: 10px; font-size: 20px;" @click.prevent="showError(item.error.message)">mdi-alert-circle</v-icon>
                                        <v-icon v-else style="margin: 10px; font-size: 20px;">mdi-check-circle</v-icon>
                                    </template>
                                    <template v-slot:item.toEntry="{ item }">
                                        <v-checkbox class="check" v-model="item.toEntry" @click.prevent="switchEntryData(item)" :disabled="item.error && item.error.selloRecibidoRequired"></v-checkbox>
                                        <!-- <v-icon style="margin: 10px; font-size: 20px;" @click.prevent="deleteFile(item)">mdi-delete</v-icon> -->
                                    </template>
                                    <template v-slot:item.TipoIngresoProveedores="{ item }">
                                        <span class="scroll-fixing-purchase">
                                            <select
                                                style="width: calc(100% - 30px); padding: 5px"
                                                class="form-control custom-select"
                                                v-model="item.TipoIngresoProveedores"
                                                @change="scrollTableToRight"
                                            >
                                                <option :value="null">Seleccionar</option>
                                                <option v-for="tipo in tipoIngresoProveedoresList" :value="tipo.Codigo" :key="tipo.Codigo">
                                                    {{ tipo.Valores }}
                                                </option>
                                            </select>
                                            <v-icon>mdi-arrow-down</v-icon>
                                        </span>
                                    </template>
                                    <template v-slot:item.SectorProveedores="{ item }">
                                        <span class="scroll-fixing-purchase">
                                            <select
                                                style="width: calc(100% - 30px); padding: 5px"
                                                class="form-control custom-select"
                                                v-model="item.SectorProveedores"
                                                @change="scrollTableToRight"
                                            >
                                                <option :value="null">Seleccionar</option>
                                                <option v-for="sector in sectorProveedoresList" :value="sector.Codigo" :key="sector.Codigo">
                                                    {{ sector.Valores }}
                                                </option>
                                            </select>
                                            <v-icon>mdi-arrow-down</v-icon>
                                        </span>
                                    </template>
                                    <template v-slot:item.ClasificationRent="{ item }">
                                        <span class="scroll-fixing-purchase">
                                            <select
                                                style="width: calc(100% - 30px); padding: 5px"
                                                class="form-control custom-select"
                                                v-model="item.ClasificationRent"
                                                @change="scrollTableToRight"
                                            >
                                                <option :value="null">Seleccionar</option>
                                                <option v-for="clasificacion in comprasClasificacionRenta" :value="clasificacion.Codigo" :key="clasificacion.Codigo">
                                                    {{ clasificacion.Valores }}
                                                </option>
                                            </select>
                                            <v-icon>mdi-arrow-down</v-icon>
                                        </span>
                                    </template>
                                    <template v-slot:item.PaymentCondition="{ item }">
                                        <span class="scroll-fixing-purchase">
                                            <select
                                                style="width: calc(100% - 30px); padding: 5px"
                                                class="form-control custom-select"
                                                v-model="item.PaymentCondition"
                                                @change="scrollTableToRight"
                                            >
                                                <option value="Contado">Contado</option>
                                                <option value="Crédito">Crédito</option>
                                            </select>
                                            <v-icon>mdi-arrow-down</v-icon>
                                        </span>
                                    </template>
                                    <template v-slot:item.delete="{ item }">
                                        <v-icon style="margin: 10px; font-size: 20px;" @click.prevent="deleteFile(item)">mdi-delete</v-icon>
                                    </template>
                                </v-data-table>
                                <v-card-actions style="padding: 1rem; justify-content: space-between;">
                                    <v-btn class="btncontinue" @click="prevStep">Anterior</v-btn>
                                    <v-btn class="btncontinue" @click="nextStep">Continuar</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-stepper-content>

                <!-- Step 3: Configuración de Cuentas del Proveedor -->
                <v-stepper-content step="3">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-step">
                                <v-card-title class="font-weight-bold text-nowrap">{{ hasDclDocuments ? 'Configuración de Cuentas' : 'Configuración de Cuentas del Proveedor' }}</v-card-title>

                                <v-card-text v-if="hasDclDocuments" class="pt-0">
                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <div class="font-weight-bold mb-2">Comisión</div>
                                            <v-radio-group v-model="dclCommissionAccountSource" column class="mt-0">
                                                <v-radio
                                                    label="Contabilizar Comisión en la cuenta del Proveedor"
                                                    value="provider"
                                                ></v-radio>
                                                <v-radio
                                                    label="Contabilizar Comisión en la cuenta de Parametrización General"
                                                    value="general"
                                                ></v-radio>
                                            </v-radio-group>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <div class="font-weight-bold mb-2">Cuentas por Cobrar</div>
                                            <v-radio-group v-model="dclReceivableAccountSource" column class="mt-0">
                                                <v-radio
                                                    label="Contabilizar Cuentas por Cobrar en la cuenta del Proveedor"
                                                    value="provider"
                                                ></v-radio>
                                                <v-radio
                                                    label="Contabilizar Cuentas por Cobrar en la cuenta de Parametrización General"
                                                    value="general"
                                                ></v-radio>
                                            </v-radio-group>
                                        </v-col>
                                    </v-row>
                                </v-card-text>

                                <!-- Configuración Seleccionada -->
                                <v-card-text v-if="selectedAccountConfiguration">
                                    <v-alert type="info" outlined>
                                        <strong>Configuración Seleccionada:</strong><br>
                                        Clasificación: {{ selectedAccountConfiguration.classification }}<br>
                                        Condición de Pago: {{ selectedAccountConfiguration.condition }}<br>
                                        <strong>Cuentas Requeridas según items:</strong>
                                        <ul style="margin-left: 20px; margin-top: 5px;">
                                            <li v-if="data.some(item => item.toEntry && item.ClasificationRent == '2')">Cuenta de Gastos</li>
                                            <li v-if="data.some(item => item.toEntry && item.ClasificationRent == '1')">Cuenta de Costos</li>
                                            <li v-if="data.some(item => item.toEntry && item.PaymentCondition === 'Contado')">Cuenta de Banco</li>
                                            <li v-if="data.some(item => item.toEntry && item.PaymentCondition === 'Crédito')">Cuenta de Cuentas Por Pagar</li>
                                        </ul>
                                    </v-alert>
                                </v-card-text>

                                <!-- Configuración Requerida -->
                                <v-card-text v-if="providersNeedingConfiguration.length > 0">
                                    <v-alert type="warning" outlined>
                                        <strong>Configuración Requerida:</strong> Algunos proveedores necesitan que se configuren las cuentas faltantes<br>
                                        Proveedores que necesitan configuración: {{ providersNeedingConfiguration.length }}
                                    </v-alert>
                                </v-card-text>

                                <v-data-table
                                    :headers="dynamicProviderAccountHeaders"
                                    :items="providerAccountsData"
                                    :items-per-page="50"
                                    :footer-props="{
                                        showFirstLastPage: true,
                                        firstIcon: 'mdi-page-first',
                                        lastIcon: 'mdi-page-last',
                                        'items-per-page-options': [50, 100, 250],
                                        'items-per-page-text':'Items por pagina:',
                                    }"
                                    class="data-table"
                                >
                                    <template v-slot:item.clasificaciones="{ item }">
                                        <div style="display: flex; gap: 4px; flex-wrap: wrap;">
                                            <v-chip
                                                v-for="c in item.clasificaciones"
                                                :key="c"
                                                x-small
                                                :color="c === '2' ? 'orange darken-1' : 'blue darken-1'"
                                                dark
                                            >
                                                {{ c === '2' ? 'Gasto' : 'Costo' }}
                                            </v-chip>
                                        </div>
                                    </template>

                                    <!-- Slot para Cuenta de Gastos con indicador de requerido -->
                                    <template v-slot:item.CuentaGastos="{ item }">
                                        <div style="display: flex; align-items: center; gap: 5px;">
                                            <span
                                                v-if="item.requiredAccounts && item.requiredAccounts.includes('CuentaGastos')"
                                                :class="item.missingAccounts && item.missingAccounts.includes('CuentaGastos') ? 'error--text font-weight-bold' : 'success--text font-weight-bold'"
                                            >
                                                {{ item.missingAccounts && item.missingAccounts.includes('CuentaGastos') ? 'Requerida' : 'Configurado' }}
                                            </span>
                                            <span v-else style="opacity: 0.5;">
                                                {{ item.CuentaGastos }}
                                            </span>
                                        </div>
                                    </template>

                                    <!-- Slot para Cuenta de Costos con indicador de requerido -->
                                    <template v-slot:item.CuentaCostos="{ item }">
                                        <div style="display: flex; align-items: center; gap: 5px;">
                                            <span
                                                v-if="item.requiredAccounts && item.requiredAccounts.includes('CuentaCostos')"
                                                :class="item.missingAccounts && item.missingAccounts.includes('CuentaCostos') ? 'error--text font-weight-bold' : 'success--text font-weight-bold'"
                                            >
                                                {{ item.missingAccounts && item.missingAccounts.includes('CuentaCostos') ? 'Requerida' : 'Configurado' }}
                                            </span>
                                            <span v-else style="opacity: 0.5;">
                                                {{ item.CuentaCostos }}
                                            </span>
                                        </div>
                                    </template>

                                    <!-- Slot para Cuenta de Banco con indicador de requerido -->
                                    <template v-slot:item.CuentaBanco="{ item }">
                                        <div style="display: flex; align-items: center; gap: 5px;">
                                            <span
                                                v-if="item.requiredAccounts && item.requiredAccounts.includes('CuentaBanco')"
                                                :class="item.missingAccounts && item.missingAccounts.includes('CuentaBanco') ? 'error--text font-weight-bold' : 'success--text font-weight-bold'"
                                            >
                                                {{ item.missingAccounts && item.missingAccounts.includes('CuentaBanco') ? 'Requerida' : 'Configurado' }}
                                            </span>
                                            <span v-else style="opacity: 0.5;">
                                                {{ item.CuentaBanco }}
                                            </span>
                                        </div>
                                    </template>

                                    <!-- Slot para Cuenta de Cuentas Por Pagar con indicador de requerido -->
                                    <template v-slot:item.CuentaCuentasPorPagar="{ item }">
                                        <div style="display: flex; align-items: center; gap: 5px;">
                                            <span
                                                v-if="item.requiredAccounts && item.requiredAccounts.includes('CuentaCuentasPorPagar')"
                                                :class="item.missingAccounts && item.missingAccounts.includes('CuentaCuentasPorPagar') ? 'error--text font-weight-bold' : 'success--text font-weight-bold'"
                                            >
                                                {{ item.missingAccounts && item.missingAccounts.includes('CuentaCuentasPorPagar') ? 'Requerida' : 'Configurado' }}
                                            </span>
                                            <span v-else style="opacity: 0.5;">
                                                {{ item.CuentaCuentasPorPagar }}
                                            </span>
                                        </div>
                                    </template>

                                    <!-- Slot para Cuenta de Gasto Comisión con indicador de requerido -->
                                    <template v-slot:item.GastoComision="{ item }">
                                        <div style="display: flex; align-items: center; gap: 5px;">
                                            <span
                                                v-if="item.requiredAccounts && item.requiredAccounts.includes('GastoComision')"
                                                :class="item.missingAccounts && item.missingAccounts.includes('GastoComision') ? 'error--text font-weight-bold' : 'success--text font-weight-bold'"
                                            >
                                                {{ item.missingAccounts && item.missingAccounts.includes('GastoComision') ? 'Requerida' : 'Configurado' }}
                                            </span>
                                            <span v-else style="opacity: 0.5;">
                                                {{ item.GastoComision }}
                                            </span>
                                        </div>
                                    </template>

                                    <!-- Slot para Cuenta de Cuentas Por Cobrar con indicador de requerido -->
                                    <template v-slot:item.CuentasPorCobrar="{ item }">
                                        <div style="display: flex; align-items: center; gap: 5px;">
                                            <span
                                                v-if="item.requiredAccounts && item.requiredAccounts.includes('CuentasPorCobrar')"
                                                :class="item.missingAccounts && item.missingAccounts.includes('CuentasPorCobrar') ? 'error--text font-weight-bold' : 'success--text font-weight-bold'"
                                            >
                                                {{ item.missingAccounts && item.missingAccounts.includes('CuentasPorCobrar') ? 'Requerida' : 'Configurado' }}
                                            </span>
                                            <span v-else style="opacity: 0.5;">
                                                {{ item.CuentasPorCobrar }}
                                            </span>
                                        </div>
                                    </template>
                                    <!-- Botón de acción para Cuenta de Gastos -->
                                    <template v-slot:item.actionsGastos="{ item }">
                                        <v-btn
                                            :color="item.requiredAccounts && item.requiredAccounts.includes('CuentaGastos') ? 'primary' : 'grey lighten-1'"
                                            :class="!(item.requiredAccounts && item.requiredAccounts.includes('CuentaGastos')) ? 'grey--text text--darken-2' : ''"
                                            small
                                            @click="selectProviderForConfiguration(item, 'CuentaGastos')"
                                        >
                                            Seleccionar
                                        </v-btn>
                                    </template>

                                    <!-- Botón de acción para Cuenta de Costos -->
                                    <template v-slot:item.actionsCostos="{ item }">
                                        <v-btn
                                            :color="item.requiredAccounts && item.requiredAccounts.includes('CuentaCostos') ? 'primary' : 'grey lighten-1'"
                                            :class="!(item.requiredAccounts && item.requiredAccounts.includes('CuentaCostos')) ? 'grey--text text--darken-2' : ''"
                                            small
                                            @click="selectProviderForConfiguration(item, 'CuentaCostos')"
                                        >
                                            Seleccionar
                                        </v-btn>
                                    </template>

                                    <!-- Botón de acción para Cuenta de Banco -->
                                    <template v-slot:item.actionsBanco="{ item }">
                                        <v-btn
                                            :color="item.requiredAccounts && item.requiredAccounts.includes('CuentaBanco') ? 'primary' : 'grey lighten-1'"
                                            :class="!(item.requiredAccounts && item.requiredAccounts.includes('CuentaBanco')) ? 'grey--text text--darken-2' : ''"
                                            small
                                            @click="selectProviderForConfiguration(item, 'CuentaBanco')"
                                        >
                                            Seleccionar
                                        </v-btn>
                                    </template>

                                    <!-- Botón de acción para Cuenta de Gasto Comisión -->
                                    <template v-slot:item.actionsGastoComision="{ item }">
                                        <v-btn
                                            :color="item.requiredAccounts && item.requiredAccounts.includes('GastoComision') ? 'primary' : 'grey lighten-1'"
                                            :class="!(item.requiredAccounts && item.requiredAccounts.includes('GastoComision')) ? 'grey--text text--darken-2' : ''"
                                            small
                                            @click="selectProviderForConfiguration(item, 'GastoComision')"
                                        >
                                            Seleccionar
                                        </v-btn>
                                    </template>

                                    <!-- Botón de acción para Cuenta de Cuentas Por Cobrar -->
                                    <template v-slot:item.actionsCuentasPorCobrar="{ item }">
                                        <v-btn
                                            :color="item.requiredAccounts && item.requiredAccounts.includes('CuentasPorCobrar') ? 'primary' : 'grey lighten-1'"
                                            :class="!(item.requiredAccounts && item.requiredAccounts.includes('CuentasPorCobrar')) ? 'grey--text text--darken-2' : ''"
                                            small
                                            @click="selectProviderForConfiguration(item, 'CuentasPorCobrar')"
                                        >
                                            Seleccionar
                                        </v-btn>
                                    </template>
                                    <!-- Botón de acción para Cuenta de Cuentas Por Pagar -->
                                    <template v-slot:item.actionsCuentasPorPagar="{ item }">
                                        <v-btn
                                            :color="item.requiredAccounts && item.requiredAccounts.includes('CuentaCuentasPorPagar') ? 'primary' : 'grey lighten-1'"
                                            :class="!(item.requiredAccounts && item.requiredAccounts.includes('CuentaCuentasPorPagar')) ? 'grey--text text--darken-2' : ''"
                                            small
                                            @click="selectProviderForConfiguration(item, 'CuentaCuentasPorPagar')"
                                        >
                                            Seleccionar
                                        </v-btn>
                                    </template>

                                </v-data-table>

                                <v-card-actions style="padding: 1rem; justify-content: space-between;">
                                    <v-btn class="btncontinue" @click="prevStep">Anterior</v-btn>
                                    <v-btn class="btncontinue" @click="nextStep">Continuar</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-stepper-content>

                <!-- Step 4: Accounting Entries -->
                <v-stepper-content step="4">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-step">
                                <v-card-title class="font-weight-bold text-nowrap">Creación de Partidas Contables</v-card-title>
                                <v-card-text>
                                    <v-alert type="info" outlined>
                                        <strong>Información:</strong> Configure las partidas contables que se generarán para cada gasto procesado.
                                        Las partidas se crearán automáticamente basadas en la configuración de cuentas seleccionada.
                                        <br>
                                        <em>La vista previa se actualiza automáticamente al cambiar cualquier parámetro de configuración.</em>
                                    </v-alert>
                                </v-card-text>

                                <!-- Configuración general de partidas -->
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                v-model="accountingEntryConfig.concept"
                                                label="Concepto de la partida"
                                                outlined
                                                dense
                                                hint="Concepto general que se aplicará a todas las partidas generadas"
                                                persistent-hint
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-select
                                                v-model="accountingEntryConfig.type"
                                                :items="TypesItems"
                                                item-text="accounting_entry_name"
                                                item-value="id_accounting_entry_type"
                                                label="Tipo de partida"
                                                outlined
                                                dense
                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <DatePicker
                                                :date="accountingEntryDate"
                                                @dateSelected="changeAccountingDate"
                                                label="Fecha de la partida"
                                            />
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-select
                                                v-model="accountingEntryConfig.nameType"
                                                :items="accountingNameOptions"
                                                item-text="text"
                                                item-value="value"
                                                label="Nombre de las partidas contables"
                                                outlined
                                                dense
                                                hint="Define cómo se nombrarán los elementos de las partidas contables"
                                                persistent-hint
                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                </v-card-text>

                                <!-- Alert informativo para nombres personalizados -->
                                <v-card-text v-if="accountingEntryConfig.nameType === 'empty'">
                                    <v-alert
                                        :type="emptyItemsCount > 0 ? 'warning' : 'info'"
                                        outlined
                                        dense
                                    >
                                        <div class="d-flex align-center">
                                            <v-icon class="mr-2" :color="emptyItemsCount > 0 ? 'warning' : 'info'">
                                                {{ emptyItemsCount > 0 ? 'mdi-alert-circle' : 'mdi-information' }}
                                            </v-icon>
                                            <div>
                                                <strong>Nombres personalizados:</strong>
                                                <span v-if="emptyItemsCount > 0" class="error--text">
                                                    {{ emptyItemsCount }} item(s) sin nombre. Complete todos los nombres antes de continuar.
                                                </span>
                                                <span v-else class="success--text">
                                                    Todos los items tienen nombres asignados.
                                                </span>
                                            </div>
                                        </div>
                                    </v-alert>
                                </v-card-text>

                                <!-- Vista previa de la estructura de partidas -->
                                <v-card-text v-if="accountingEntriesPreview.length > 0">
                                    <v-expansion-panels v-model="previewPanel" multiple>
                                        <v-expansion-panel>
                                            <v-expansion-panel-header>
                                                <strong>Vista previa de partidas contables ({{ accountingEntriesPreview.length }} partida(s))</strong>
                                            </v-expansion-panel-header>
                                            <v-expansion-panel-content>
                                                <div v-for="(entry, entryIndex) in accountingEntriesPreview" :key="entryIndex" class="mb-4">
                                                    <v-card outlined>
                                                        <v-card-subtitle>
                                                            <strong>Partida {{ entryIndex + 1 }}</strong>
                                                            <br>Concepto: {{ entry.concept }}
                                                            <br>Fecha: {{ entry.date }}
                                                            <br>Total Debe: ${{ entry.totalDebe.toFixed(2) }}
                                                            <br>Total Haber: ${{ entry.totalHaber.toFixed(2) }}
                                                        </v-card-subtitle>
                                                        <v-card-text>
                                                            <v-data-table
                                                                :headers="accountingEntryHeaders"
                                                                :items="entry.details"
                                                                dense
                                                                hide-default-footer
                                                                disable-pagination
                                                            >
                                                                <template v-slot:item.concept="{ item }">
                                                                    <div v-if="accountingEntryConfig.nameType === 'empty'" class="d-flex align-center">
                                                                        <v-text-field
                                                                            v-model="item.concept"
                                                                            dense
                                                                            outlined
                                                                            hide-details
                                                                            @blur="updateCustomItemName(item, item.concept)"
                                                                            placeholder="Nombre personalizado"
                                                                            style="min-width: 200px;"
                                                                            :error="!item.concept || !item.concept.trim()"
                                                                        ></v-text-field>
                                                                        <v-icon
                                                                            v-if="!item.concept || !item.concept.trim()"
                                                                            color="error"
                                                                            class="ml-2"
                                                                            small
                                                                            title="Campo requerido"
                                                                        >
                                                                            mdi-alert-circle
                                                                        </v-icon>
                                                                    </div>
                                                                    <span v-else>{{ item.concept }}</span>
                                                                </template>
                                                                <template v-slot:item.Deb="{ item }">
                                                                    ${{ parseFloat(item.Deb || 0).toFixed(2) }}
                                                                </template>
                                                                <template v-slot:item.Hab="{ item }">
                                                                    ${{ parseFloat(item.Hab || 0).toFixed(2) }}
                                                                </template>
                                                            </v-data-table>
                                                        </v-card-text>
                                                    </v-card>
                                                </div>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </v-card-text>

                                <v-card-actions style="padding: 1rem; justify-content: space-between;">
                                    <v-btn class="btncontinue" @click="prevStep">Anterior</v-btn>
                                    <v-btn class="btncontinue" @click="nextStep" :disabled="loading">
                                        {{ entryOnlyMode ? 'Crear partida contable' : 'Continuar' }}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-stepper-content>

                <!-- Step 5: Preview Data -->
                <v-stepper-content v-if="!entryOnlyMode" step="5">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-step">
                                <v-card-title class="font-weight-bold text-nowrap">Gastos importados de los archivos seleccionados</v-card-title>

                                <AccountingAssign
                                    v-if="$store.getters['rolesUser/getCustomRole'](179)"
                                    v-model="account.id_account"
                                    :assignAll="true"
                                    @accountChanged="accountChanged"
                                    @assignAllAccounts="assignAllAccounts"
                                >
                                </AccountingAssign>

                                <v-data-table
                                    :headers="expensesHeaders"
                                    :items="expensesData"
                                    :items-per-page="50"
                                    :footer-props="{
                                        showFirstLastPage: true,
                                        firstIcon: 'mdi-page-first',
                                        lastIcon: 'mdi-page-last',
                                        'items-per-page-options': [50, 100, 250],
                                        'items-per-page-text':'Items por pagina:',
                                    }"
                                    class="data-table"
                                >
                                    <template v-slot:item.accountSearchButton="{ item, index }">
                                        <span class="">
                                            <a @click="chooseAccount( index )">
                                                <v-icon>mdi-magnify</v-icon>
                                            </a>
                                        </span>
                                    </template>
                                    <template v-slot:item.ItemDeclarationType="{ item, index }">
                                        <span class="scroll-fixing-purchase">
                                            <select
                                                style="width: calc(100% - 30px); padding: 5px"
                                                class="form-control custom-select"
                                                v-model="item.ItemDeclarationType"
                                                @change="e => data[ index ].ItemDeclarationType = e.target.value"
                                            >
                                                <option v-for="tipoItem in tipoItemCompraGasto" :value="tipoItem.Codigo" :key="tipoItem.Codigo">
                                                    {{ tipoItem.Valores }}
                                                </option>
                                            </select>
                                            <v-icon>mdi-arrow-down</v-icon>
                                        </span>
                                    </template>
                                    <template v-slot:item.account_code="{ item, index }">
                                        <span
                                            v-if="!isSelectShowed"
                                            @click="toggleSelect(index)"
                                            >
                                            {{ item.account_code ?? 'Seleccionar cuenta' }}
                                            <v-icon>mdi-arrow-down</v-icon>
                                        </span>
                                        <span v-else class="scroll-fixing-purchase">
                                            <select
                                                style="width: calc(100% - 30px); padding: 5px"
                                                class="form-control custom-select"
                                                v-model="item.id_account"
                                                @change="(e) => handleChangeAccount(e, index)"
                                                @blur="handleBlurOnSelect"
                                                :ref="`accountListSelect-${index}`"
                                            >
                                                <option v-for="accountItem in accountList" :value="accountItem.id_account" :key="accountItem.id_account">
                                                    {{ accountItem.account_description }}
                                                </option>
                                            </select>
                                            <v-icon>mdi-arrow-down</v-icon>
                                        </span>
                                    </template>
                                </v-data-table>
                                <v-card-actions style="padding: 1rem; justify-content: space-between;">
                                    <v-btn class="btncontinue" @click="prevStep">Anterior</v-btn>
                                    <v-btn class="btnoption" @click="onClickProcess">Procesar</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-stepper-content>

                <!-- Step 6: Process Data -->
                <v-stepper-content v-if="!entryOnlyMode" step="6">
                    <v-row>
                        <v-col cols="12">
                            <v-card v-if="loading" class="card-step">
                                <v-card-title class="font-weight-bold text-nowrap">Procesando la información importada</v-card-title>
                                <!-- <v-card-text style="padding: 0 16px;">
                                    <v-progress-linear
                                        v-if="loading"
                                        indeterminate
                                        color="primary"
                                        class="my-4"
                                    ></v-progress-linear>
                                </v-card-text>
                                <div style="height: 50px;"></div> -->
                            </v-card>
                            <v-card v-else class="card-step">
                                <v-card-title class="font-weight-bold text-nowrap">Estado del procesamiento de datos</v-card-title>

                                <v-card-text v-if="!processError && processed.length">
                                    <h3 style="margin-top: 20px; margin-bottom: 20px; font-size: 16px;">
                                        Se han procesado un total de {{ processed.length }} facturas de gastos importadas desde los archivos seleccionados.
                                    </h3>
                                    <v-card-actions style="padding: 0px; gap: 50px;">
                                        <v-btn class="btnoption" @click="showProcessed=!showProcessed" style="min-width: 100px;">
                                            {{!showProcessed ? 'Ver' : 'Ocultar'}}
                                            <v-icon v-if="!showProcessed" style="margin-left: 5px;">mdi-menu-down</v-icon>
                                            <v-icon v-else style="margin-left: 5px;">mdi-menu-up</v-icon>
                                        </v-btn>
                                        <v-btn class="btnoption" @click="goToModifyAccountingEntry" style="background-color: #00a178 !important;">
                                            <span>Modificar partida contable</span>
                                            <v-icon>mdi-pencil</v-icon>
                                        </v-btn>
                                    </v-card-actions>
                                </v-card-text>
                                <v-data-table
                                    v-if="showProcessed"
                                    :headers="processHeaders"
                                    :items="processed"
                                    :items-per-page="50"
                                    :footer-props="{
                                        showFirstLastPage: true,
                                        firstIcon: 'mdi-page-first',
                                        lastIcon: 'mdi-page-last',
                                        'items-per-page-options': [50, 100, 250],
                                        'items-per-page-text':'Items por pagina:',
                                    }"
                                    class="data-table"
                                >
                                    <template v-slot:item.status="{}">
                                        <v-icon style="margin: 10px; font-size: 20px;">mdi-check-circle</v-icon>
                                    </template>
                                </v-data-table>

                                <v-card-text v-if="!processError && notProcessed.length">
                                    <h3 style="margin-top: 20px; margin-bottom: 20px; font-size: 16px; color: #e3191e !important;">
                                        No se logro procesar un total de {{ notProcessed.length }} facturas de gastos importadas, debido a la existencia de errores en la información.
                                    </h3>
                                    <v-card-actions style="padding: 0px; gap: 50px;">
                                        <v-btn class="btnoption" @click="showNotProcessed=!showNotProcessed" style="min-width: 100px;">
                                            {{!showNotProcessed ? 'Ver' : 'Ocultar'}}
                                            <v-icon v-if="!showNotProcessed" style="margin-left: 5px;">mdi-menu-down</v-icon>
                                            <v-icon v-else style="margin-left: 5px;">mdi-menu-up</v-icon>
                                        </v-btn>
                                        <!-- <v-btn class="btnoption" @click="exportToExcel('ERROR')" style="background-color: #00a178 !important;">
                                            <v-icon>mdi-file-excel</v-icon>
                                        </v-btn> -->
                                    </v-card-actions>
                                </v-card-text>
                                <v-data-table
                                    v-if="showNotProcessed"
                                    :headers="processHeaders"
                                    :items="notProcessed"
                                    :items-per-page="50"
                                    :footer-props="{
                                        showFirstLastPage: true,
                                        firstIcon: 'mdi-page-first',
                                        lastIcon: 'mdi-page-last',
                                        'items-per-page-options': [50, 100, 250],
                                        'items-per-page-text':'Productos por pagina:',
                                    }"
                                    class="data-table"
                                >
                                    <template v-slot:item.status="{ item }">
                                        <v-icon v-if="item.error?.provider" color="red darken-4" style="margin: 10px; font-size: 20px;" @click.prevent="showError(item.error?.message || 'Ha ocurrido un error al insertar el proveedor de esta factura de gastos.')">mdi-alert-circle</v-icon>
                                        <v-icon v-else-if="item.error?.isDuplicated" color="red darken-4" style="margin: 10px; font-size: 20px;" @click.prevent="showError(item.error?.message || 'Esta factura de gastos ya se encuentra registrada en la base de datos.')">mdi-alert-circle</v-icon>
                                        <v-icon v-else color="red darken-4" style="margin: 10px; font-size: 20px;" @click.prevent="showError(item.error?.message || 'Ha ocurrido un error al insertar la factura de gastos de este archivo JSON.')">mdi-alert-circle</v-icon>
                                    </template>
                                </v-data-table>

                                <v-card-text v-if="processError" style="display: flex; flex-direction: row;">
                                    <h3 style="margin-top: 20px; margin-bottom: 20px; font-size: 16px;">
                                        Ha ocurrido un error en el procesamiento, vuelva a intentarlo más tarde.
                                    </h3>
                                </v-card-text>

                                <v-card-text v-if="!expensesData.length" style="display: flex; flex-direction: row;">
                                    <h3 style="margin-top: 20px; margin-bottom: 20px; font-size: 16px;">
                                        No existen productos pendiente de procesamiento.
                                    </h3>
                                </v-card-text>

                                <v-card-actions style="padding: 1rem; justify-content: space-between;">
                                    <v-btn class="btncontinue" @click="prevStep" :disabled="expensesData.length > 0 || expensesData.length > 0">Anterior</v-btn>
                                    <v-btn class="btncontinue" @click="resetAll">Volver al inicio</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-stepper-content>

            </v-stepper-items>
        </v-stepper>
        <alerts
            v-if="alert.show"
            v-on:close_alert="closeAlert"
            v-on:accept_alert="acceptAlert"
            v-on:secondary_alert="secondaryAlert"
            :properties="alert"
        >
        </alerts>
        <v-dialog v-model="showModal" :width="dialogWidth">
            <v-card>
                <AccountingItemForm
                    :win="win"
                    v-on:sendSelection="accountSelectionHandler"
                    v-on:closeDialog="showModal = false"
                />
            </v-card>
        </v-dialog>
        <GlobalDiscountDistribution ref="discountDistribution" />
    </div>
</template>

<script>
import Alerts from "@/components/Alerts";
import Block from "@/components/Block";
import AccountingAssign from "./AccountingAssign.vue";
import * as XLSX from "xlsx";
import CustomCSVPeriod from "../../../components/Misc/CustomCSVPeriod.vue";
import ClasificationRentaAutocomplete from "../../../components/Misc/ClasificationRentaAutocomplete.vue";
import { mapGetters } from "vuex";
import AccountingItemForm from "./AccountingItemForm.vue";
import DatePicker from "@/components/DatePicker";
import { findSelloRecibido, parseJsonRelaxedCanonical } from "@/helpers/parseJson";
import GlobalDiscountDistribution from "../../../components/Misc/GlobalDiscountDistribution.vue";
import moment from 'moment';

export default {
    name: "ExpenseManagmentMassiveEntryAdvanced",
    props: {
        win: {
            type: Object,
            default: null
        },
        entryOnlyMode: {
            type: Boolean,
            default: false
        },
        storedExpense: {
            type: Object,
            default: null
        },
        storedExpenseDetails: {
            type: Array,
            default: () => []
        }
    },
    components: {
        Block,
        Alerts,
        AccountingAssign,
        CustomCSVPeriod,
        ClasificationRentaAutocomplete,
        AccountingItemForm,
        GlobalDiscountDistribution,
        DatePicker
    },
    data() {
        return {
            step: 1,
            loading: false,
            dataLoaded: false,
            selectAll: true,
            percentageIvaCheck: true,
            percentageIva: 100,
            id_bussiness: null,
            bussiness: null,
            id_branch: null,
            id_user: null,
            selectedFiles: [],
            selectedFilesNames: [],
            currentJson: null,
            dataFiles: [],
            headerFiles: [],
            data: [],
            invalidJsonFiles: [],  // Archivos JSON que no se pudieron procesar
            headers: [],
            expensesData: [],
            expensesHeaders: [],
            processHeaders: [],

            accountList: [],
            isSelectShowed: false,
            account: {
                id_account: null
            },

            errors: null,
            processError: false,

            processed: [],
            notProcessed: [],
            showNotProcessed: false,
            showProcessed: false,
            duplicateDocuments: [],

            invoiceType: [null, "FCF", "CCF", "NC", "FNS", "FEX", "DCL", "ND"],
            paymentMethod: [ "Efectivo", "Cheque", "Transferencia", "Tarjeta de Crédito", "Otro" ],
            invoiceStatus: ["Pendiente de pago", "Cancelada", "Crédito", "Anulada"],
            days: ['8 Dias', '15 Dias', '30 Dias', '90 Dias', '120 Dias', '180 Dias'],

            alert: {
                type: "success",
                show: false,
                header: "",
                body: "",
                onAccept: null,
            },
            CustomCSVPeriodFlag: false,
            CustomCSVPeriodYear: null,
            CustomCSVPeriodMonth: null,
            submitCustomCSVPeriodState: false,
            cleanState: false,
            targetIndex: null,
            showModal: false,

            // Configuración de cuentas del proveedor
            selectedAccountConfiguration: null,
            providersNeedingConfiguration: [],
            providerAccountsData: [],
            selectedProviderForConfig: null,
            selectedAccountType: null,
            dclCommissionAccountSource: 'provider',
            dclReceivableAccountSource: 'provider',

            // Configuración de partidas contables
            accountingEntryConfig: {
                concept: "",
                type: null,
                nameType: "numeroControl", // Opciones: "empty", "codigoGeneracion", "numeroControl", "concept"
            },
            // Para almacenar nombres personalizados de cada item cuando nameType es "empty"
            customItemNames: {},
            accountingEntryDate: null,
            accountingEntriesPreview: [],
            accountingEntriesWarningMessage: "",
            previewPanel: [0],
            TypesItems: [],
            accountingEntryHeaders: [
                { text: 'Código Cuenta', value: 'account_code' },
                { text: 'Descripción', value: 'account_description' },
                { text: 'Nombre', value: 'concept' },
                { text: 'Debe', value: 'Deb' },
                { text: 'Haber', value: 'Hab' }
            ],

            // Debounce timer para regenerar vista previa
            previewGenerationTimer: null,
            branchAccountsConfig: null,

            // Opciones para el selector de nombres de partidas
            accountingNameOptions: [
                { text: "Mantenerlo vacío", value: "empty" },
                { text: "Código de generación", value: "codigoGeneracion" },
                { text: "Número de control", value: "numeroControl" },
                { text: "Mismo concepto de partida", value: "concept" }
            ],

            // Variables para generación de correlativo
            lastAccountingCorrelative: '',

            // Variable para almacenar los datos de la partida contable creada
            createdAccountingEntryData: null,

            // Campos de clasificación para asignar a todos
            globalTipoIngresoProveedores: null,
            globalSectorProveedores: null,
            globalClasificationRent: '2',
            globalPaymentCondition: 'Contado',
        };
    },
    async mounted() {
        this.id_bussiness = JSON.parse(localStorage.getItem("user")).businessid;
        this.business = JSON.parse(localStorage.getItem("user")).business;
        this.id_branch = JSON.parse(localStorage.getItem("user")).branch;
        this.id_user = JSON.parse(localStorage.getItem("user")).id;

        // Hacer moment disponible globalmente en el componente
        this.moment = moment;

        // Inicializar fecha para partidas contables
        this.accountingEntryDate = moment().format("DD/MM/YYYY");

        await this.getAllAccounts();
        await this.getAcounteringType();
        await this.getAccountsConfig();
        await this.getLastAcountingCorrelative();

        this.headers = [
            {text: '' , value: 'toEntry'},
            {text: 'Estado' , value: 'status'},
            {text: 'Fecha' , value: 'fecEmi'},
            {text: 'Número Control' , value: 'numeroControl'},
            {text: 'Codigo Generación' , value: 'codigoGeneracion'},
            {text: 'Tipo de factura' , value: 'invoiceType'},
            {text: 'ID Proveedor' , value: 'provider'},
            {text: 'NIT Proveedor' , value: 'nit'},
            {text: 'NRC Proveedor' , value: 'nrc'},
            {text: 'Nombre Proveedor' , value: 'nombre'},
            {text: 'Nombre Comercial Proveedor' , value: 'nombreComercial'},

            {text: 'ivaRete1' , value: 'ivaRete1'},
            {text: 'ivaPerci1' , value: 'ivaPerci1'},
            {text: 'totalIva' , value: 'totalIva'},
            {text: 'reteRenta' , value: 'reteRenta'},
            {text: 'descuNoSuj' , value: 'descuNoSuj'},
            {text: 'descuExenta' , value: 'descuExenta'},
            {text: 'descuGravada' , value: 'descuGravada'},
            {text: 'porcentajeDescuento' , value: 'porcentajeDescuento'},
            {text: 'totalDescu' , value: 'totalDescu'},
            {text: 'totalNoSuj' , value: 'totalNoSuj'},
            {text: 'totalExenta' , value: 'totalExenta'},
            {text: 'totalGravada' , value: 'totalGravada'},
            {text: 'totalNoGravado' , value: 'totalNoGravado'},
            {text: 'subTotalVentas' , value: 'subTotalVentas'},

            {text: 'Total Operación' , value: 'montoTotalOperacion'},
            {text: 'Total a Pagar' , value: 'totalPagar'},
            {text: 'Tipo Ingreso' , value: 'TipoIngresoProveedores'},
            {text: 'Sector' , value: 'SectorProveedores'},
            {text: 'Condición de Pago' , value: 'PaymentCondition'},
            {text: 'Clasificación Renta' , value: 'ClasificationRent'},
            {text: '' , value: 'delete'},
        ];
        this.expensesHeaders = [
            {text: '' , value: 'accountSearchButton'},
            {text: 'Código' , value: 'account_code'},
            {text: 'Cuenta' , value: 'account_name'},
            {text: 'Fecha' , value: 'fecEmi'},
            {text: 'Número control' , value: 'numeroControl'},
            {text: 'Codigo generación' , value: 'codigoGeneracion'},
            {text: 'Tipo de factura' , value: 'invoiceType'},
            {text: 'Proveedor' , value: 'provider'},
            {text: 'Nombre del gasto' , value: 'descripcion'},
            {text: 'Precio' , value: 'precioUni'},
            {text: 'Cantidad' , value: 'cantidad'},
            {text: 'Estado' , value: 'condicionOperacion'},
            {text: 'Gasto declarable como:' , value: 'ItemDeclarationType'},
            {text: 'Descuento' , value: 'montoDescu'},
            {text: 'Total no sujeto' , value: 'ventaNoSuj'},
            {text: 'Total exento' , value: 'ventaExenta'},
            {text: 'Total gravado' , value: 'ventaGravada'},
            {text: 'Total a pagar' , value: 'totalPagar'},
            {text: 'Cuenta Contable' , value: 'account_code'},
        ];

        this.processHeaders = [
            {text: 'Estado' , value: 'status'},
            {text: 'Fecha' , value: 'fecEmi'},
            {text: 'Número Control' , value: 'numeroControl'},
            {text: 'Codigo Generación' , value: 'codigoGeneracion'},
            {text: 'Tipo de factura' , value: 'invoiceType'},
            {text: 'ID Proveedor' , value: 'provider'},
            {text: 'NIT Proveedor' , value: 'nit'},
            {text: 'NRC Proveedor' , value: 'nrc'},
            {text: 'Nombre Proveedor' , value: 'nombre'},
            {text: 'Nombre Comercial Proveedor' , value: 'nombreComercial'},
            {text: 'Sub Total' , value: 'subTotal'},
            {text: 'Total Operación' , value: 'montoTotalOperacion'},
            {text: 'Total a Pagar' , value: 'totalPagar'},
        ];

        if (this.entryOnlyMode) {
            this.initializeStoredExpenseMode();
        }
    },

    beforeDestroy() {
        // Limpiar timer de vista previa si existe
        if (this.previewGenerationTimer) {
            clearTimeout(this.previewGenerationTimer);
        }
    },

    watch: {
        /* tableData: {
            deep: true,
            inmediate: true,
            handler(newValue) {
                this.errors = newValue.some((item) => item.error);
            }
        }, */
        selectedFiles: {
            deep: true,
            inmediate: true,
            handler(newValue) {
                for (const item of newValue) {
                    this.selectedFilesNames.push({name: item.name});
                }
            }
        },
        data: {
            deep: true,
            inmediate: true,
            handler(newValue) {
                for (const item of newValue) {
                    if(item.toEntry == false) {
                        this.selectAll = false;
                    }
                }
            }
        },

        // Watchers para regenerar vista previa automáticamente
        'accountingEntryConfig.concept': {
            handler() {
                this.debouncedGeneratePreview();
            }
        },
        'accountingEntryConfig.type': {
            handler() {
                this.debouncedGeneratePreview();
            }
        },
        'accountingEntryConfig.nameType': {
            handler() {
                // Siempre regenerar cuando cambia el tipo de nombre
                // ya que esto afecta cómo se muestran los nombres
                this.generateAccountingEntriesPreview();
            }
        },
        customItemNames: {
            deep: true,
            handler() {
                // No regenerar la vista previa cuando solo cambian los nombres
                // Los nombres se actualizan directamente en updateCustomItemName
                // Solo regenerar si no estamos en el paso 4 o si es necesario
                if (this.step !== 4) {
                    this.debouncedGeneratePreview();
                }
            }
        },
        accountingEntryDate: {
            deep: true,
            handler() {
                this.debouncedGeneratePreview();
            }
        },

        // Watchers para hacer scroll cuando cambian clasificaciones globales
        globalClasificationRent: {
            handler() {
                this.$nextTick(() => {
                    this.scrollTableToRight();
                });
            }
        },
        globalPaymentCondition: {
            handler() {
                this.$nextTick(() => {
                    this.scrollTableToRight();
                });
            }
        },
        globalSectorProveedores: {
            handler() {
                this.$nextTick(() => {
                    this.scrollTableToRight();
                });
            }
        },
        globalTipoIngresoProveedores: {
            handler() {
                this.$nextTick(() => {
                    this.scrollTableToRight();
                });
            }
        },
        dclCommissionAccountSource: {
            handler() {
                this.refreshProviderRequirements();
            }
        },
        dclReceivableAccountSource: {
            handler() {
                this.refreshProviderRequirements();
            }
        },

    },
    computed: {
        ...mapGetters(["getCatalogMH"]),
        dialogWidth() {
            return this.$vuetify.breakpoint.smAndDown ? "95%" : "60%";
        },
        tipoItemCompraGasto() {
            return this.getCatalogMH("TipoItemCompraGasto");
        },
        tipoIngresoProveedoresList() {
            return this.getCatalogMH("TipoIngresoProveedores");
        },
        sectorProveedoresList() {
            return this.getCatalogMH("SectorProveedores");
        },
        comprasClasificacionRenta() {
            return this.getCatalogMH("ComprasClasificacionRenta");
        },
        emptyItemsCount() {
            if (this.accountingEntryConfig.nameType !== 'empty' || this.accountingEntriesPreview.length === 0) {
                return 0;
            }

            let count = 0;
            this.accountingEntriesPreview.forEach(entry => {
                entry.details.forEach(item => {
                    const itemName = item.concept || '';
                    if (!itemName.trim()) {
                        count++;
                    }
                });
            });

            return count;
        },
        hasDclDocuments() {
            const items = [...(this.data || []), ...(this.dataFiles || [])];
            return items.some(item => this.isDclExpense(item));
        },
        dynamicProviderAccountHeaders() {
            const baseHeaders = [
                { text: 'Número Proveedor', value: 'ID_Provider' },
                { text: 'Nombre Proveedor', value: 'ProviderName' },
                { text: 'NIT Proveedor', value: 'nit' },
                { text: 'Clasificación', value: 'clasificaciones' }
            ];

            // Agregar headers según la configuración seleccionada
            const requiredAccounts = [];

            // Obtener todas las clasificaciones únicas de los items que no sean DCL
            const allClassifications = [...new Set(
                this.data
                    .filter(item => item.toEntry === true && !this.isDclExpense(item))
                    .map(item => item.ClasificationRent)
                    .filter(c => c != null)
            )];

            // Validar según las clasificaciones individuales de los items no DCL
            if (allClassifications.length === 0) {
                // Si no hay clasificaciones no DCL, no solicitar CuentaGastos por DCL
            } else {
                // Agregar cuentas según las clasificaciones encontradas
                if (allClassifications.includes('2')) { // Hay items de Gasto
                    requiredAccounts.push('CuentaGastos');
                }
                if (allClassifications.includes('1')) { // Hay items de Costo
                    requiredAccounts.push('CuentaCostos');
                }
            }

            // Validar según PaymentCondition por items activos
            const allPayments = [...new Set(this.data.filter(item => item.toEntry === true).map(item => item.PaymentCondition).filter(c => c != null))];
            if (allPayments.length === 0 || allPayments.includes('Contado')) {
                requiredAccounts.push('CuentaBanco');
            }
            if (allPayments.includes('Crédito')) {
                requiredAccounts.push('CuentaCuentasPorPagar');
            }

            requiredAccounts.push(...this.getDclRequiredProviderAccounts());
            requiredAccounts.forEach(accountType => {
                let accountName = '';
                let actionText = '';
                let actionValue = '';

                switch(accountType) {
                    case 'CuentaBanco':
                        accountName = 'Cuenta Banco';
                        actionText = 'Acción Banco';
                        actionValue = 'actionsBanco';
                        break;
                    case 'CuentaCostos':
                        accountName = 'Cuenta Costos';
                        actionText = 'Acción Costos';
                        actionValue = 'actionsCostos';
                        break;
                    case 'CuentaCuentasPorPagar':
                        accountName = 'Cuenta Cuentas Por Pagar';
                        actionText = 'Acción Cuentas Por Pagar';
                        actionValue = 'actionsCuentasPorPagar';
                        break;
                    case 'CuentaGastos':
                        accountName = 'Cuenta Gastos';
                        actionText = 'Acción Gastos';
                        actionValue = 'actionsGastos';
                        break;
                    case 'GastoComision':
                        accountName = 'Cuenta Gasto Comisión';
                        actionText = 'Acción Gasto Comisión';
                        actionValue = 'actionsGastoComision';
                        break;
                    case 'CuentasPorCobrar':
                        accountName = 'Cuenta Cuentas Por Cobrar';
                        actionText = 'Acción Cuentas Por Cobrar';
                        actionValue = 'actionsCuentasPorCobrar';
                        break;
                }
                if (accountName) {
                    baseHeaders.push({ text: accountName, value: accountType });
                    baseHeaders.push({ text: actionText, value: actionValue });
                }
            });

            return baseHeaders;
        },
    },
    methods: {
        chooseAccount(index) {
            this.showModal =true
            this.targetIndex = index;
        },
        async accountSelectionHandler(data) {
            this.showModal = false;
            const { id_account, account_code, account_description } = data;

            // Si estamos configurando cuentas para un proveedor específico
            if (this.selectedProviderForConfig) {
                await this.updateProviderAccount(this.selectedProviderForConfig, { id_account, account_code, account_description });
                this.selectedProviderForConfig = null;
                return;
            }

            // Lógica original para configuración de gastos individuales
            if (this.targetIndex !== null) {
                this.$set(this.expensesData[ this.targetIndex ], 'id_account', id_account);
                this.$set(this.expensesData[ this.targetIndex ], 'account_code', account_code);
                this.$set(this.expensesData[ this.targetIndex ], 'account_name', account_description);
                this.data[ this.targetIndex ].id_account = id_account;
                this.data[ this.targetIndex ].account_code = account_code;
                this.data[ this.targetIndex ].account_name = account_description;
            }
        },
        accountChanged( e ) {
            this.account.id_account = e
        },
        assignAllClassifications() {
            // Asignar los valores globales de clasificación a todos los registros
            this.data.forEach(item => {
                item.TipoIngresoProveedores = this.globalTipoIngresoProveedores;
                item.SectorProveedores = this.globalSectorProveedores;
                item.ClasificationRent = this.globalClasificationRent;
                if (this.globalPaymentCondition) {
                    item.PaymentCondition = this.globalPaymentCondition;
                }
            });

            // Hacer scroll horizontal de la tabla
            this.$nextTick(() => {
                this.scrollTableToRight();
            });

            // Mostrar mensaje de confirmación
            this.showAlert(
                "success",
                "Éxito",
                "Se han asignado las clasificaciones a todos los registros"
            );
        },
        scrollTableToRight() {
            // Encontrar el contenedor con scroll de la tabla
            if (this.$refs.dataTableStep2) {
                const tableWrapper = this.$refs.dataTableStep2.$el.querySelector('.v-data-table__wrapper');
                if (tableWrapper) {
                    // Hacer scroll suave hacia la derecha (máximo scroll)
                    tableWrapper.scrollTo({
                        left: tableWrapper.scrollWidth,
                        behavior: 'smooth'
                    });
                }
            }
        },
        setCustomCSVPeriod(val){
            this.CustomCSVPeriodFlag = val
        },
        setCustomCSVPeriodYear(val){
            this.CustomCSVPeriodYear = val
        },
        setCustomCSVPeriodMonth(val){
            this.CustomCSVPeriodMonth = val
        },
        async nextStep() {
            if (this.entryOnlyMode && this.step == 4) {
                await this.createStoredExpenseAccountingEntry();
                return;
            }

            if(this.step === 1) {
                if(this.selectedFiles.length && !this.dataLoaded) {
                    this.showAlert("warning", "Advertencia", "Antes de continuar debe cargar los archivos seleccionados.");
                    return;
                }
            }
            if(this.step == 2) {
                let errors = 0;

                if( this.CustomCSVPeriodFlag ) {
                    this.submitCustomCSVPeriodState = true;
                    !this.CustomCSVPeriodMonth && ( errors += 1 );
                    !this.CustomCSVPeriodYear && ( errors += 1 );
                }

                if (errors > 0) {
                    this.showAlert(
                        "warning",
                        "Advertencia",
                        "Debe llenar todos los campos obligatorios"
                    );
                    return;
                }

                // Configurar cuentas del proveedor al pasar del paso 2 al 3
                await this.configureProviderAccounts();
                // Incrementar el paso después de la configuración
                this.step++;
                return;
            }
            if(this.step == 3) {
                // El paso 3 ya tiene la validación hecha, continuar al siguiente paso
                // y generar automáticamente la vista previa de partidas contables
                this.step++;
                this.$nextTick(() => {
                    this.generateAccountingEntriesPreview();
                });
                return;
            }
            if(this.step == 4) {
                // Validar configuración de partidas contables
                if (!this.accountingEntryConfig.concept || !this.accountingEntryConfig.type) {
                    this.showAlert("warning", "Advertencia", "Debe completar la configuración de partidas contables.");
                    return;
                }

                // La vista previa se genera automáticamente, solo verificamos que exista
                if (this.accountingEntriesPreview.length === 0) {
                    // Si no hay vista previa, intentar generarla
                    await this.generateAccountingEntriesPreview();
                    if (this.accountingEntriesPreview.length === 0) {
                        this.showAlert("warning", "Advertencia", "No se pudieron generar las partidas contables. Verifique la configuración.");
                        return;
                    }
                }

                // Validar que todos los items tengan nombres cuando nameType es 'empty'
                const nameValidation = this.validateAccountingEntryNames();
                if (!nameValidation.valid) {
                    this.showAlert("warning", "Items sin nombre", nameValidation.message);
                    return;
                }

                // Generar datos de gastos para previsualización
                this.handleExpensesDetails();
                this.step++;
                return;
            }
            if(this.step == 5) {
                // Paso de previsualización, solo continuar
                this.step++;
                return;
            }
            this.step++;
        },
        prevStep() {
            if (this.entryOnlyMode && this.step <= 2) {
                this.$emit('cancel');
                return;
            }

            this.step--;
        },
        handleFolderFiles(event) {
            this.resetData();
            const files = Array.from(event.target.files);
            const jsonFiles = files.filter(file => file.name.endsWith('.json'));

            if (jsonFiles.length > 0) {
                this.selectedFiles = [...jsonFiles];
            } else {
                alert('No se encontraron archivos JSON en el directorio seleccionado.');
            }
        },
        handleIndividualFiles(event) {
            this.resetData();
            const files = Array.from(event.target.files);
            const jsonFiles = files.filter(file => file.name.endsWith('.json') || file.name.endsWith('.JSON'));

            if (jsonFiles.length > 0) {
                this.selectedFiles = [...this.selectedFiles, ...jsonFiles];
            } else {
                alert('No se encontraron archivos JSON seleccionados.');
            }
        },
        async handleFilesUpload() {
            if (!this.selectedFiles.length) {
                this.showAlert("warning", "Advertencia", "Debe seleccionar los archivos a cargar.");
                return;
            }
            this.loading = true;
            try {
                const duplicatedCodes = new Set(
                    (this.duplicateDocuments || [])
                        .map(item => this.normalizeGenerationCode(item?.codigoGeneracion))
                        .filter(Boolean)
                );
                for (const item of this.dataFiles) {
                    this.currentJson = item.identificacion.codigoGeneracion;
                    item.toEntry = true;
                    // Detectar si es la nueva versión
                    const isNewVersion = this.isNewVersionJson(item);
                    const provider = await this.checkProvider(item.emisor);
                    if(!provider){
                        //console.log('Not checked');
                        // Para nueva versión, usar datos de cuerpoDocumento.ivaPercibido en lugar de resumen.ivaPerci1
                        const ivaPerci1Value = isNewVersion ? item.cuerpoDocumento.ivaPercibido : item.resumen?.ivaPerci1;
                        const newProvider = await this.addProvider({ ...item.emisor , ivaPerci1: ivaPerci1Value });
                        if(newProvider && newProvider.ID_Provider) {
                            item.provider = newProvider.ID_Provider;
                            item.id_account = newProvider.id_purchases_account ? newProvider.id_purchases_account : null;
                            //this.providers = await this.getAllProviders();
                        }
                        else {
                            item.error = {
                                providerError: true,
                                message: 'No se pudo insertar el proveedor de esta factura, intentelo nuevamente más tarde.',
                            };
                            item.toEntry = false;
                        }
                    }
                    else {
                        //console.log('Provider checked', provider);
                        item.provider = provider.ID_Provider;
                        item.id_account = provider.id_purchases_account ? provider.id_purchases_account : null;
                        item.account_code = provider.id_purchases_account ? this.accountList.find(i => i.id_account == provider.id_purchases_account)?.account_code : null;
                        item.account_description = provider.id_purchases_account ? this.accountList.find(i => i.id_account == provider.id_purchases_account)?.account_description : null;
                    }
                    const normalizedCode = this.normalizeGenerationCode(item.identificacion?.codigoGeneracion);
                    const duplicateDocument = this.getDuplicateDocumentByCode(normalizedCode);
                    const isPurchaseDuplicate = duplicateDocument?.source === 'purchase';
                    if(duplicatedCodes.has(normalizedCode)) {
                        item.error = {
                            ...(item.error || {}),
                            isDuplicated: !isPurchaseDuplicate,
                            purchaseDuplicate: isPurchaseDuplicate,
                            message: item.error?.message ? item.error?.message : (isPurchaseDuplicate ? 'Esta factura ya se encuentra registrada como compra de inventario.' : 'Esta factura ya se encuentra registrada, si desea sobreescribir la información existente debera seleccionar el checkbox.')
                        };
                    }

                    if(item.identificacion.tipoDte == "03") item.invoiceType = "CCF";
                    if(item.identificacion.tipoDte == "05") item.invoiceType = "NC";
                    if(item.identificacion.tipoDte == "06") item.invoiceType = "ND";
                    if(item.identificacion.tipoDte == "11") item.invoiceType = "FEX";
                    if(item.identificacion.tipoDte == "14") item.invoiceType = "FNS";
                    //if(item.identificacion.tipoDte == "15") item.invoiceType = "CDD";
                    if(item.identificacion.tipoDte == "01") item.invoiceType = "FCF";
                    if(item.identificacion.tipoDte == "09") item.invoiceType = "DCL";

                    let tributos = {
                        iva: 0,
                    };

                    // Detectar si es la nueva versión
                    const isNewVersionFormat = this.isNewVersionJson(item);

                    if (!isNewVersionFormat && item.resumen && item.resumen.tributos && item.resumen.tributos.length) {
                        // Versión original - procesar tributos desde resumen
                        let index = 11;
                        for (const el of item.resumen.tributos) {
                            if(el.codigo == '20' || el.descripcion.includes('IVA')){
                                tributos.iva = el.valor;
                                if((this.headers.some(i => i.value == 'iva')) !== true) {
                                    this.headers.splice(index, 0, {text: 'IVA' , value: 'iva'});
                                    index += 1;
                                }
                            }
                            else if(el.codigo == 'D1' || el.descripcion.includes('FOVIAL')){
                                tributos.fovial = el.valor;
                                if((this.headers.some(i => i.value == 'fovial')) !== true) {
                                    this.headers.splice(index, 0, {text: 'Fovial' , value: 'fovial'});
                                    index += 1;
                                }
                            }
                            else if(el.codigo == 'C8' || el.descripcion.includes('COTRANS')){
                                tributos.cotrans = el.valor;
                                if((this.headers.some(i => i.value == 'cotrans')) !== true) {
                                    this.headers.splice(index, 0, {text: 'Cotrans' , value: 'cotrans'});
                                    index += 1;
                                }
                            }
                            else {
                                tributos[el.descripcion] = el.valor;
                                if((this.headers.some(i => i.value == el.descripcion)) !== true) {
                                    this.headers.splice(index, 0, {text: el.descripcion , value: el.descripcion});
                                    index += 1;
                                }
                            }
                        }
                    } else if (isNewVersionFormat && item.cuerpoDocumento) {
                        // Nueva versión - extraer IVA desde cuerpoDocumento
                        tributos.iva = item.cuerpoDocumento.iva || 0;
                        if(tributos.iva > 0 && (this.headers.some(i => i.value == 'iva')) !== true) {
                            this.headers.splice(11, 0, {text: 'IVA' , value: 'iva'});
                        }
                    }
                    if(item.invoiceType == "FEX" && !isNewVersionFormat && item.resumen) {
                        item.flete = item.resumen.flete;
                        item.seguro = item.resumen.seguro;
                    }

                    let rowData;

                    if (isNewVersionFormat) {
                        // Nueva versión - usar datos de cuerpoDocumento
                        rowData = {
                            ...item,
                            ivaRete1: 0, // No esta en la version nueva creada para mantener el formato original
                            ivaPerci1: item.cuerpoDocumento.ivaPercibido || 0,
                            totalIva: item.cuerpoDocumento.iva || 0,
                            reteRenta: 0, // No esta en la version nueva creada para mantener el formato original
                            descuNoSuj: 0, // No esta en la version nueva creada para mantener el formato original
                            descuExenta: 0, // No esta en la version nueva creada para mantener el formato original
                            descuGravada: 0, // No esta en la version nueva creada para mantener el formato original
                            porcentajeDescuento: 0, // No esta en la version nueva creada para mantener el formato original
                            totalDescu: 0, // No esta en la version nueva creada para mantener el formato original
                            totalNoSuj: 0, // No esta en la version nueva creada para mantener el formato original
                            totalExenta: 0, // No esta en la version nueva creada para mantener el formato original
                            totalGravada: item.cuerpoDocumento.valorOperaciones || 0,
                            totalNoGravado: 0, // No esta en la version nueva creada para mantener el formato original
                            subTotalVentas: item.cuerpoDocumento.subTotal || 0,
                            fecEmi: this.formatDate(item.identificacion.fecEmi),
                            numeroControl: item.identificacion.numeroControl,
                            codigoGeneracion: item.identificacion.codigoGeneracion,
                            invoiceType: item.invoiceType,
                            provider: item.provider,
                            nit: item.emisor.nit,
                            nrc: item.emisor.nrc,
                            nombre: item.emisor.nombre,
                            nombreComercial: item.emisor.nombreComercial,
                            subTotal: item.cuerpoDocumento.subTotal || 0,
                            montoTotalOperacion: item.cuerpoDocumento.valorOperaciones || 0,
                            totalPagar: item.cuerpoDocumento.liquidoApagar || 0,
                            toEntry: item.toEntry,
                            error: item.error || null,
                            dteJson: item,
                            ItemDeclarationType: 2,
                            // Campos específicos de la nueva versión
                            comision: item.cuerpoDocumento.comision || 0,
                            ivaComision: item.cuerpoDocumento.ivaComision || 0,
                            montoSujetoPercepcion: item.cuerpoDocumento.montoSujetoPercepcion || 0,
                            montoSinPercepcion: item.cuerpoDocumento.montoSinPercepcion || 0,
                            empleadoEntrega: item.extension ? item.extension.nombEntrega : null,
                            codigoEmpleado: item.extension ? item.extension.codEmpleado : null,
                            selloRecibido: findSelloRecibido(item),
                            // Campos de clasificación para anexos
                            TipoIngresoProveedores: null,
                            SectorProveedores: null,
                            ClasificationRent: '2',
                            PaymentCondition: 'Contado'
                        };
                    } else {
                        // Versión original
                        const totalPagar = item.resumen?.totalPagar || item.resumen?.montoTotalOperacion || 0;
                        rowData = {
                            ...item,
                            ivaRete1: item.resumen?.ivaRete1 || 0,
                            ivaPerci1: item.resumen?.ivaPerci1 || 0,
                            totalIva: item.resumen?.totalIva || 0,
                            reteRenta: item.resumen?.reteRenta || 0,
                            descuNoSuj: item.resumen?.descuNoSuj || 0,
                            descuExenta: item.resumen?.descuExenta || 0,
                            descuGravada: item.resumen?.descuGravada || 0,
                            porcentajeDescuento: item.resumen?.porcentajeDescuento || 0,
                            totalDescu: item.resumen?.totalDescu || 0,
                            totalNoSuj: item.resumen?.totalNoSuj || 0,
                            totalExenta: item.resumen?.totalExenta || 0,
                            totalGravada: item.resumen?.totalGravada || 0,
                            totalNoGravado: item.resumen?.totalNoGravado || 0,
                            subTotalVentas: item.resumen?.subTotalVentas || 0,
                            fecEmi: this.formatDate(item.identificacion.fecEmi),
                            numeroControl: item.identificacion.numeroControl,
                            codigoGeneracion: item.identificacion.codigoGeneracion,
                            invoiceType: item.invoiceType,
                            provider: item.provider,
                            nit: item.emisor.nit,
                            nrc: item.emisor.nrc,
                            nombre: item.emisor.nombre,
                            nombreComercial: item.emisor.nombreComercial,
                            subTotal: item.resumen?.subTotal || 0,
                            montoTotalOperacion: item.resumen?.montoTotalOperacion || 0,
                            totalPagar: totalPagar,
                            toEntry: item.toEntry,
                            error: item.error || null,
                            dteJson: item,
                            ItemDeclarationType: 2,
                            selloRecibido: findSelloRecibido(item),
                            // Campos de clasificación para anexos
                            TipoIngresoProveedores: null,
                            SectorProveedores: null,
                            ClasificationRent: '2',
                            PaymentCondition: 'Contado'
                        };
                    }

                    for (const prop in tributos) {
                        rowData = {
                            ...rowData,
                            [prop]: tributos[prop]
                        }
                    }

                    // Validación de selloRecibido: Si ivaPerci1 > 0, selloRecibido es requerido
                    const ivaPerci1Value = rowData.ivaPerci1 || 0;
                    const selloRecibidoValue = rowData.selloRecibido;

                    if (ivaPerci1Value > 0 && (!selloRecibidoValue || selloRecibidoValue.trim() === '')) {
                        // Si hay percepción de IVA pero no hay sello recibido, marcar como error
                        rowData.error = {
                            selloRecibidoRequired: true,
                            message: rowData.error?.message
                                ? `${rowData.error.message} Además, el sello recibido es requerido cuando hay percepción de IVA.`
                                : 'El sello recibido es requerido para facturas con percepción de IVA (1%).'
                        };
                        rowData.toEntry = false;
                    }

                    this.data.push(rowData);
                }
                setTimeout(() => {
                    this.loading = false;
                    this.dataLoaded = true;
                    this.currentJson = null;
                    //console.log(this.data);

                    // Mostrar alerta informativa si hay archivos inválidos
                    if (this.invalidJsonFiles.length > 0) {
                        this.showAlert("warning", "Archivos procesados con advertencias",
                            `Se cargaron ${this.data.length} archivo(s) válido(s) correctamente.\n\n` +
                            `${this.invalidJsonFiles.length} archivo(s) no pudieron procesarse debido a errores de formato o estructura.\n\n` +
                            `Puede revisar los archivos inválidos en la tabla superior y presionar "Continuar" cuando esté listo.`);
                    } else {
                        this.showAlert("success", "Exito", "Los archivos seleccionados fueron cargados correctamente.");
                    }
                }, 1000);
            }
            catch (error) {

                const fileName = this.selectedFilesNames.find(item => item.name.includes(this.currentJson));
                this.loading = false;
                if(fileName && fileName.name) {
                    this.showAlert("warning", "Advertencia", `Ha ocurrido un error al cargar el archivo ${fileName.name}, revise la estructura del JSON.`);
                }
                else {
                    this.showAlert("warning", "Advertencia", "Ha ocurrido un error al cargar los archivos, vuelva a intentarlo más tarde.");
                }
                this.currentJson = null;
            }
        },
        async duplicatedValidation() {
            this.loading = true;
            this.invalidJsonFiles = [];  // Limpiar lista de inválidos
            let formatErrorFiles = []
            // Procesar los archivos JSON seleccionados
            for (const file of this.selectedFiles) {
                if (file.type === "application/json") {
                    try {
                        const content = await this.readFile(file);
                        const jsonContent = parseJsonRelaxedCanonical(content);
                        const currentCode = this.normalizeGenerationCode(jsonContent?.identificacion?.codigoGeneracion);
                        const isInDataFiles = currentCode
                            ? this.dataFiles.some(item => this.normalizeGenerationCode(item?.identificacion?.codigoGeneracion) === currentCode)
                            : false;
                        jsonContent['fileName'] = file.name;
                        if (!isInDataFiles) {
                            this.dataFiles.push(jsonContent);
                        }
                        // Los duplicados se omiten automáticamente
                    } catch (error) {
                        console.error(`Error parsing JSON file ${file.name}:`, error);
                        formatErrorFiles.push({
                            fileName: file.name,
                            error: `Error de formato JSON: ${error.message}`
                        });
                    }
                }
            }

            // Guardar archivos con error de formato
            this.invalidJsonFiles.push(...formatErrorFiles);

            // Manejar archivos JSON inválidos
            if (formatErrorFiles.length > 0 && this.dataFiles.length === 0) {
                // Si todos los archivos son inválidos, mostrar error y detener
                const errorDetails = formatErrorFiles.map(item => `${item.fileName}: ${item.error}`).join('\n');
                this.showAlert("warning", "Error de formato JSON",
                    `Todos los archivos tienen errores de formato JSON y no pueden ser procesados:\n\n${errorDetails}\n\nPor favor, corrija estos archivos antes de continuar.`);
                this.loading = false;
                return;
            }

            // Si hay archivos válidos, continuar con la validación de estructura (sin mostrar alerta aún)
            this.structureValidation();

        },
        structureValidation() {

            // Validar estructura de archivos
            const structureInvalidFiles = this.dataFiles.filter(file => !this.jsonValidation(file));
            this.dataFiles = this.dataFiles.filter(file => this.jsonValidation(file));

            // Agregar archivos con estructura inválida a la lista
            structureInvalidFiles.forEach(file => {
                this.invalidJsonFiles.push({
                    fileName: file.fileName,
                    error: 'Estructura JSON inválida (faltan campos requeridos)'
                });
            });

            // Si no hay archivos válidos, mostrar error y detener
            if (this.dataFiles.length === 0) {
                this.showAlert("warning", "Advertencia", "Ninguno de los archivos tiene la estructura correcta. Por favor, revise los archivos y corríjalos antes de continuar.");
                this.loading = false;
                return;
            }

            // Continuar con la validación de códigos de generación duplicados
            this.validateStoredGenerationCodes();
        },
        jsonValidation(json) {
            if (!json) return false;

            // Detectar si es la nueva versión del JSON (DCL - Declaración de Comisiones por Liquidación)
            const isNewVersion = this.isNewVersionJson(json);

            if (isNewVersion) {
                // Validación para la nueva versión
                const newVersionAttributes = [
                    'emisor',
                    'receptor',
                    'identificacion',
                    'cuerpoDocumento',
                    'extension'
                    // responseMH es opcional en la nueva versión
                ];

                for (const key of newVersionAttributes) {
                    if (!Object.prototype.hasOwnProperty.call(json, key)) {
                        console.error(`Falta el atributo principal para nueva versión: ${key}`);
                        return false;
                    }
                }
            } else {
                // Validación para la versión original
                const principalAttributes = [
                    'emisor',
                    //'donante',
                    'receptor',
                    'resumen',
                    'identificacion',
                    'cuerpoDocumento'
                ];

                for (const key of principalAttributes) {
                    if (!Object.prototype.hasOwnProperty.call(json, key)) {
                        console.error(`Falta el atributo principal: ${key}`);
                        return false;
                    }
                }
            }

            return true;
        },
        isNewVersionJson(json) {
            // Detecta si es la nueva versión basándose en:
            // 1. Presencia de 'extension'
            // 2. tipoDte "09" (DCL)
            // 3. cuerpoDocumento como objeto (no array)
            return json.extension &&
                   json.identificacion?.tipoDte === "09" &&
                   json.cuerpoDocumento &&
                   !Array.isArray(json.cuerpoDocumento);
        },
        normalizeGenerationCode(value) {
            if (value === null || value === undefined) {
                return null;
            }

            const normalized = String(value).trim().replace(/[\s-]+/g, "");
            return normalized.length > 0 ? normalized : null;
        },
        groupDuplicateDocuments(duplicates) {
            const grouped = new Map();

            duplicates.forEach((duplicate) => {
                const code = this.normalizeGenerationCode(duplicate?.codigoGeneracion);
                if (!code) {
                    return;
                }

                if (!grouped.has(code)) {
                    grouped.set(code, new Set());
                }

                const sourceLabel = duplicate?.sourceLabel
                    || (duplicate?.source === 'purchase' ? 'Compras de inventario' : 'Gastos');
                grouped.get(code).add(sourceLabel);
            });

            return Array.from(grouped.entries()).map(([codigoGeneracion, labels]) => ({
                codigoGeneracion,
                sourceLabels: Array.from(labels),
            }));
        },
        buildDuplicateBody(duplicates) {
            const duplicateLines = this.groupDuplicateDocuments(duplicates)
                .map(({ codigoGeneracion, sourceLabels }) => `El documento ${codigoGeneracion} ya fue agregado en ${sourceLabels.join(' y ')}.`);

            duplicateLines.push('¿Desea continuar de todas formas?');
            return duplicateLines.join('<br>');
        },
        getDuplicateDocumentByCode(code) {
            const normalizedCode = this.normalizeGenerationCode(code);
            return (this.duplicateDocuments || []).find(
                (duplicate) => this.normalizeGenerationCode(duplicate?.codigoGeneracion) === normalizedCode
            ) || null;
        },
        async validateStoredGenerationCodes() {
            const generationCodes = [...new Set(
                this.dataFiles
                    .map(item => this.normalizeGenerationCode(item?.identificacion?.codigoGeneracion))
                    .filter(Boolean)
            )];

            this.duplicateDocuments = [];

            if (generationCodes.length === 0) {
                this.handleFilesUpload();
                return;
            }

            try {
                const response = await this.$API.accountingexpensesentry.verifyGenerationCodes({
                    codigosGeneracion: generationCodes
                });

                const duplicates = Array.isArray(response?.duplicates) ? response.duplicates : [];
                this.duplicateDocuments = duplicates;

                if (duplicates.length > 0) {
                    this.loading = false;
                    this.showAlert(
                        "question3",
                        "Advertencia",
                        `Uno o más documentos ya fueron agregados al sistema.<br><br>${this.buildDuplicateBody(duplicates)}`,
                        "duplicateDocuments"
                    );
                    return;
                }

                this.handleFilesUpload();
            } catch (error) {
                console.error(error);
                this.loading = false;
                this.showAlert(
                    "warning",
                    "Advertencia",
                    "No fue posible validar si los documentos ya existen en el sistema."
                );
            }
        },

        // Métodos para configuración de cuentas del proveedor
        async configureProviderAccounts() {
            this.loading = true;
            try {
                if (this.entryOnlyMode) {
                    const row = this.data[0] || {};
                    const expense = this.storedExpense || {};
                    const providerDetails = {
                        ID_Provider: expense.ID_Provider || row.provider,
                        ProviderName: expense.ProviderName || row.nombre,
                        CuentaBanco: expense.ProviderCuentaBanco || null,
                        CuentaCostos: expense.ProviderCuentaCostos || null,
                        CuentaCuentasPorPagar: expense.ProviderCuentaCuentasPorPagar || null,
                        CuentaGastos: expense.ProviderCuentaGastos || null,
                        IsGlobalBranch: expense.IsGlobalBranch || 0
                    };
                    const nit = row.nit || expense.ProviderLegalNIT || expense.ID_Provider;

                    this.providerAccountsData = [];
                    this.addProviderToAccountsData(providerDetails, nit);
                    this.determineProviersNeedingConfiguration();
                    return;
                }

                // Obtener lista única de proveedores del JSON
                const uniqueProviders = this.getUniqueProvidersFromData();

                // Limpiar datos previos
                this.providerAccountsData = [];

                // Para cada proveedor único, obtener detalles usando getProviderByNIT
                for (const providerData of uniqueProviders) {
                    if (providerData.nit) {
                        try {
                            const response = await this.$API.accountingexpenses.getProviderByNIT(providerData.nit);
                            if (response.data && response.data.length > 0) {
                                const providerDetails = response.data[0];
                                this.addProviderToAccountsData(providerDetails, providerData.nit);
                            } else {
                                // Proveedor no encontrado, agregar como proveedor que necesita configuración
                                this.addUnknownProviderToAccountsData(providerData);
                            }
                        } catch (error) {
                            this.addUnknownProviderToAccountsData(providerData);
                        }
                    }
                }

                // Determinar cuáles proveedores necesitan configuración
                this.determineProviersNeedingConfiguration();

            } catch (error) {
                this.showAlert("danger", "Error", "Error al configurar las cuentas de proveedores");
            } finally {
                this.loading = false;
            }
        },

        getUniqueProvidersFromData() {
            const providerMap = new Map();

            this.dataFiles.forEach(item => {
                if (item.emisor && item.emisor.nit && item.toEntry === true) {
                    const nit = item.emisor.nit;
                    if (!providerMap.has(nit)) {
                        providerMap.set(nit, {
                            nit: nit,
                            nombre: item.emisor.nombre,
                            nombreComercial: item.emisor.nombreComercial
                        });
                    }
                }
            });

            return Array.from(providerMap.values());
        },

        getRequiredAccountsForProvider(providerNit) {
            const requiredAccounts = [];

            // Buscar todos los items de este proveedor en this.data
            const providerItems = this.data.filter(item => item.nit === providerNit && item.toEntry === true);
            const providerHasDclItems = providerItems.some(item => this.isDclExpense(item));
            const classificationItems = providerHasDclItems
                ? providerItems.filter(item => !this.isDclExpense(item))
                : providerItems;

            // Obtener todas las clasificaciones únicas de los items no DCL del proveedor
            const uniqueClassifications = [...new Set(classificationItems.map(item => item.ClasificationRent).filter(c => c != null))];

            // Si no hay items no DCL con clasificación, no solicitar CuentaGastos por DCL
            if (uniqueClassifications.length === 0) {
                if (!providerHasDclItems) {
                    requiredAccounts.push('CuentaGastos'); // Por defecto es Gasto
                }
            } else {
                // Agregar cuentas según las clasificaciones individuales de los items
                if (uniqueClassifications.includes('2')) { // Algún item es Gasto
                    requiredAccounts.push('CuentaGastos');
                }
                if (uniqueClassifications.includes('1')) { // Algún item es Costo
                    requiredAccounts.push('CuentaCostos');
                }
            }

            // Validar según PaymentCondition por item del proveedor
            const uniquePayments = [...new Set(providerItems.map(item => item.PaymentCondition).filter(c => c != null))];
            if (uniquePayments.length === 0 || uniquePayments.includes('Contado')) {
                requiredAccounts.push('CuentaBanco');
            }
            if (uniquePayments.includes('Crédito')) {
                requiredAccounts.push('CuentaCuentasPorPagar');
            }

            // Validar cuentas DCL según el estado de los radiobuttons
            if (providerHasDclItems) {
                if (this.dclCommissionAccountSource === 'provider') {
                    requiredAccounts.push('GastoComision');
                }
                if (this.dclReceivableAccountSource === 'provider') {
                    requiredAccounts.push('CuentasPorCobrar');
                }
            }

            return requiredAccounts;
        },

        getDclRequiredProviderAccounts() {
            const requiredAccounts = [];

            if (this.hasDclDocuments && this.dclCommissionAccountSource === 'provider') {
                requiredAccounts.push('GastoComision');
            }

            if (this.hasDclDocuments && this.dclReceivableAccountSource === 'provider') {
                requiredAccounts.push('CuentasPorCobrar');
            }

            return requiredAccounts;
        },

        addProviderToAccountsData(providerDetails, nit) {
            // Determinar qué cuentas necesita según las clasificaciones individuales de los items del proveedor
            const requiredAccounts = this.getRequiredAccountsForProvider(nit);

            // Obtener clasificaciones únicas de los items del proveedor
            const providerItems = this.data.filter(item => item.nit === nit && item.toEntry === true);
            const uniqueClassifications = [...new Set(providerItems.map(item => item.ClasificationRent).filter(c => c != null))];
            const clasificaciones = uniqueClassifications.length === 0
                ? ['2'] // Por defecto Gasto
                : uniqueClassifications;

            // Verificar si tiene las cuentas requeridas
            const missingAccounts = [];
            let needsConfiguration = false;

            requiredAccounts.forEach(accountType => {
                if (!providerDetails[accountType] || providerDetails[accountType] === null) {
                    missingAccounts.push(accountType);
                    needsConfiguration = true;
                }
            });

            this.providerAccountsData.push({
                ID_Provider: providerDetails.ID_Provider,
                ProviderName: providerDetails.ProviderName,
                nit: nit,
                clasificaciones: clasificaciones,
                CuentaBanco: this.getAccountDisplayText(providerDetails.CuentaBanco) || 'Sin configurar',
                CuentaCostos: this.getAccountDisplayText(providerDetails.CuentaCostos) || 'Sin configurar',
                CuentaCuentasPorPagar: this.getAccountDisplayText(providerDetails.CuentaCuentasPorPagar) || 'Sin configurar',
                CuentaGastos: this.getAccountDisplayText(providerDetails.CuentaGastos) || 'Sin configurar',
                GastoComision: this.getAccountDisplayText(providerDetails.GastoComision) || 'Sin configurar',
                CuentasPorCobrar: this.getAccountDisplayText(providerDetails.CuentasPorCobrar) || 'Sin configurar',
                // Guardar también los IDs para uso en partidas contables
                CuentaBanco_ID: providerDetails.CuentaBanco || null,
                CuentaCostos_ID: providerDetails.CuentaCostos || null,
                CuentaCuentasPorPagar_ID: providerDetails.CuentaCuentasPorPagar || null,
                CuentaGastos_ID: providerDetails.CuentaGastos || null,
                GastoComision_ID: providerDetails.GastoComision || null,
                CuentasPorCobrar_ID: providerDetails.CuentasPorCobrar || null,
                needsConfiguration: needsConfiguration,
                missingAccounts: missingAccounts,
                requiredAccounts: requiredAccounts,
                providerDetails: providerDetails
            });
        },

        getAccountDisplayText(accountId) {
            if (!accountId) return null;
            const account = this.accountList.find(acc => acc.id_account != null && acc.id_account.toString() === accountId.toString());
            return account ? `${account.account_code} - ${account.account_description}` : null;
        },

        addUnknownProviderToAccountsData(providerData) {
            const requiredAccounts = this.getRequiredAccountsForProvider(providerData.nit);

            // Obtener clasificaciones únicas de los items del proveedor
            const providerItems = this.data.filter(item => item.nit === providerData.nit && item.toEntry === true);
            const uniqueClassifications = [...new Set(providerItems.map(item => item.ClasificationRent).filter(c => c != null))];
            const clasificaciones = uniqueClassifications.length === 0
                ? ['2'] // Por defecto Gasto
                : uniqueClassifications;

            this.providerAccountsData.push({
                ID_Provider: 'N/A',
                ProviderName: providerData.nombre || 'Proveedor desconocido',
                nit: providerData.nit,
                clasificaciones: clasificaciones,
                CuentaBanco: 'Sin configurar',
                CuentaCostos: 'Sin configurar',
                CuentaCuentasPorPagar: 'Sin configurar',
                CuentaGastos: 'Sin configurar',
                GastoComision: 'Sin configurar',
                CuentasPorCobrar: 'Sin configurar',
                // Inicializar IDs como null para proveedores nuevos
                CuentaBanco_ID: null,
                CuentaCostos_ID: null,
                CuentaCuentasPorPagar_ID: null,
                CuentaGastos_ID: null,
                GastoComision_ID: null,
                CuentasPorCobrar_ID: null,
                needsConfiguration: true,
                missingAccounts: requiredAccounts,
                requiredAccounts: requiredAccounts,
                isNew: true,
                providerData: providerData
            });
        },

        refreshProviderRequirements() {
            if (!Array.isArray(this.providerAccountsData) || this.providerAccountsData.length === 0) {
                this.determineProviersNeedingConfiguration();
                return;
            }

            this.providerAccountsData.forEach((provider) => {
                const requiredAccounts = this.getRequiredAccountsForProvider(provider.nit);
                const missingAccounts = requiredAccounts.filter((accountType) => {
                    const accountId = provider[`${accountType}_ID`];
                    return accountId === null || accountId === undefined || accountId === '';
                });

                this.$set(provider, 'requiredAccounts', requiredAccounts);
                this.$set(provider, 'missingAccounts', missingAccounts);
                this.$set(provider, 'needsConfiguration', missingAccounts.length > 0);
            });

            this.determineProviersNeedingConfiguration();
        },

        determineProviersNeedingConfiguration() {
            this.providersNeedingConfiguration = this.providerAccountsData.filter(provider => provider.needsConfiguration);

            // Obtener todas las clasificaciones únicas de los items
            const allClassifications = [...new Set(this.data.filter(item => item.toEntry === true).map(item => item.ClasificationRent).filter(c => c != null))];
            let classificationText = '';

            if (allClassifications.length === 0) {
                // Si no hay clasificaciones individuales, usar '2' (Gasto) como por defecto
                classificationText = 'Gasto';
            } else if (allClassifications.length === 1) {
                // Si solo hay una clasificación
                classificationText = allClassifications[0] == '2' ? 'Gasto' : 'Costo';
            } else {
                // Si hay múltiples clasificaciones
                classificationText = 'Mixto (Gasto y Costo)';
            }

            this.selectedAccountConfiguration = {
                classification: classificationText,
                condition: [...new Set(this.data.filter(i => i.toEntry).map(i => i.PaymentCondition).filter(Boolean))].join(' / ') || 'Contado'
            };
        },

        selectProviderForConfiguration(item, accountType) {
            // Abrir el modal de selección de cuentas igual que en partidas contables
            this.showModal = true;
            this.selectedProviderForConfig = item;
            this.selectedAccountType = accountType;
            this.targetIndex = null; // Reset target index for provider configuration
        },

        async updateProviderAccount(provider, accountData) {
            // Usar el tipo de cuenta que se especificó al hacer clic en el botón
            const accountType = this.selectedAccountType;

            if (accountType) {
                await this.assignAccountToProvider(provider, accountType, accountData);
            } else {
                // Si no hay tipo especificado, usar la primera cuenta faltante
                const missingAccounts = provider.missingAccounts || [];
                if (missingAccounts.length > 0) {
                    await this.assignAccountToProvider(provider, missingAccounts[0], accountData);
                } else {
                    this.showAlert("info", "Cuenta ya configurada",
                        `El proveedor ${provider.ProviderName} ya tiene todas las cuentas configuradas`);
                }
            }

            // Resetear el tipo de cuenta seleccionada
            this.selectedAccountType = null;
        },

        async assignAccountToProvider(provider, accountType, accountData) {
            try {
                // Actualizar la configuración del proveedor localmente
                provider[accountType] = `${accountData.account_code} - ${accountData.account_description}`;
                // Guardar también el ID por separado para uso en partidas contables
                provider[`${accountType}_ID`] = accountData.id_account;

                // Remover el tipo de cuenta de las cuentas faltantes
                provider.missingAccounts = provider.missingAccounts.filter(type => type !== accountType);

                // Marcar como configurada si se completaron todas las cuentas requeridas
                if (provider.missingAccounts.length === 0) {
                    provider.needsConfiguration = false;
                }

                // Actualizar la lista de proveedores que necesitan configuración
                this.determineProviersNeedingConfiguration();

                // Determinar el nombre del tipo de cuenta para el mensaje
                let accountTypeName = '';
                switch(accountType) {
                    case 'CuentaBanco':
                        accountTypeName = 'Cuenta Banco';
                        break;
                    case 'CuentaCostos':
                        accountTypeName = 'Cuenta Costos';
                        break;
                    case 'CuentaCuentasPorPagar':
                        accountTypeName = 'Cuenta Cuentas Por Pagar';
                        break;
                    case 'CuentaGastos':
                        accountTypeName = 'Cuenta Gastos';
                        break;
                    case 'GastoComision':
                        accountTypeName = 'Cuenta Gasto Comisión';
                        break;
                    case 'CuentasPorCobrar':
                        accountTypeName = 'Cuenta Cuentas Por Cobrar';
                        break;
                    default:
                        accountTypeName = accountType;
                }

                // Actualizar el proveedor en la API
                const apiUpdateSuccess = await this.updateProviderAccountInAPI(provider, accountType, accountData.id_account);

                // Actualizar también las referencias en dataFiles si corresponde
                this.updateProviderAccountInDataFiles(provider, accountType, accountData.id_account);

                // Mostrar mensaje apropiado según el resultado de la API
                if (apiUpdateSuccess) {
                    this.showAlert("success", "Cuenta Asignada",
                        `Se ha asignado la cuenta ${accountData.account_code} como ${accountTypeName} para el proveedor ${provider.ProviderName} y se actualizó en el servidor.`);
                } else {
                    this.showAlert("info", "Cuenta Asignada Localmente",
                        `Se ha asignado la cuenta ${accountData.account_code} como ${accountTypeName} para el proveedor ${provider.ProviderName}. La actualización en el servidor falló pero se mantuvo localmente.`);
                }

            } catch (error) {
                this.showAlert("danger", "Error",
                    `Error al asignar la cuenta para el proveedor ${provider.ProviderName}: ${error.message}`);
            }
        },

        updateProviderAccountInDataFiles(provider, accountType, accountId) {
            // Actualizar las referencias del proveedor en dataFiles para que los gastos usen la cuenta correcta
            this.dataFiles.forEach(item => {
                if (item.provider === provider.ID_Provider) {
                    // Obtener la clasificación individual del item desde this.data
                    const dataItem = this.data.find(d => d.codigoGeneracion === item.identificacion.codigoGeneracion);
                    const itemClasification = dataItem ? dataItem.ClasificationRent : '2'; // '2' = Gasto por defecto

                    // Solo actualizar si el tipo de cuenta coincide con la clasificación individual del item
                    if ((accountType === 'CuentaGastos' && itemClasification === '2') ||
                        (accountType === 'CuentaCostos' && itemClasification === '1')) {
                        item.id_account = accountId;
                        const account = this.accountList.find(acc => acc.id_account === accountId);
                        if (account) {
                            item.account_code = account.account_code;
                            item.account_description = account.account_description;
                        }
                    }
                }
            });

            // También actualizar en data
            this.data.forEach(item => {
                if (item.provider === provider.ID_Provider) {
                    // Usar la clasificación individual del item
                    const itemClasification = item.ClasificationRent || '2'; // '2' = Gasto por defecto

                    if ((accountType === 'CuentaGastos' && itemClasification === '2') ||
                        (accountType === 'CuentaCostos' && itemClasification === '1')) {
                        item.id_account = accountId;
                        const account = this.accountList.find(acc => acc.id_account === accountId);
                        if (account) {
                            item.account_code = account.account_code;
                            item.account_name = account.account_description;
                        }
                    }
                }
            });
        },

        async updateProviderAccountInAPI(provider, accountType, accountId) {
            try {
                // Solo actualizar si el proveedor existe (no es nuevo)
                if (provider.ID_Provider === 'N/A' || provider.isNew) {
                    return false; // No se puede actualizar un proveedor que no existe en la BD
                }

                // Mapear el tipo de cuenta al campo correcto en la API
                let updateData = {
                    ID_Provider: provider.ID_Provider,
                    ID_Business: this.id_bussiness,
                    ID_Branch: this.id_branch,
                    ID_User_Update: this.id_user
                };

                switch(accountType) {
                    case 'CuentaBanco':
                        updateData.CuentaBanco = accountId;
                        break;
                    case 'CuentaCostos':
                        updateData.CuentaCostos = accountId;
                        break;
                    case 'CuentaCuentasPorPagar':
                        updateData.CuentaCuentasPorPagar = accountId;
                        break;
                    case 'CuentaGastos':
                        updateData.CuentaGastos = accountId;
                        break;
                    case 'GastoComision':
                        updateData.GastoComision = accountId;
                        break;
                    case 'CuentasPorCobrar':
                        updateData.CuentasPorCobrar = accountId;
                        break;
                }
                const response = await this.$API.accountingexpenses.updateProviderAccounts(updateData);

                // Verificar si la respuesta es exitosa
                if (response && (response.success || response.data)) {
                    provider.providerDetails = provider.providerDetails || {};
                    provider.providerDetails[accountType] = accountId;

                    // También actualizar el ID local para uso en partidas contables
                    provider[`${accountType}_ID`] = accountId;

                    // Mostrar mensaje de éxito
                    this.showAlert("success", "Actualización Exitosa",
                        `La cuenta del proveedor ${provider.ProviderName} se actualizó correctamente en el servidor.`);

                    return true;
                } else {
                    throw new Error('La respuesta del servidor no indica éxito');
                }

            } catch (error) {
                this.showAlert("warning", "Advertencia",
                    "La cuenta se asignó localmente pero no se pudo actualizar en el servidor. Error: " +
                    (error.response?.data?.message || error.message || error.toString()));
                return false;
            }
        },

        async handleExpensesDetails() {
            this.loading = true;
            const expenses = [];
            for (const item of this.dataFiles) {
                if(item.toEntry === true && !item.error?.providerError) {
                    let processedDocument;
                    try {
                        processedDocument = await this.$refs.discountDistribution.processDocument(item);
                        this.$set(item, 'processedDocument', processedDocument);
                    } catch (error) {
                        this.showAlert('warning', 'Descuento pendiente', error.message);
                        this.loading = false;
                        return;
                    }
                    // Detectar si es la nueva versión
                    const isNewVersion = this.isNewVersionJson(item);
                    const isFEX = item.identificacion?.tipoDte === '11'
                        || item.invoiceType === 'FEX';
                    if (isNewVersion) {
                        // Nueva versión - cuerpoDocumento es un objeto
                        // Extraer numeroDocumento de documentoRelacionado si existe
                        let numeroDocumentoRelacionado = null;
                        if (item.documentoRelacionado &&
                            Array.isArray(item.documentoRelacionado) &&
                            item.documentoRelacionado.length > 0) {
                            numeroDocumentoRelacionado = item.documentoRelacionado[0].numeroDocumento || null;
                        }
                        const headerExpense = {
                            fecEmi: this.formatDate(item.identificacion.fecEmi),
                            numeroControl: item.identificacion.numeroControl,
                            codigoGeneracion: item.identificacion.codigoGeneracion,
                            documentType: 2,
                            invoiceType: item.invoiceType,
                            provider: item.provider,
                            subTotal: item.cuerpoDocumento.subTotal || 0,
                            montoTotalOperacion: item.cuerpoDocumento.valorOperaciones || 0,
                            totalPagar: item.cuerpoDocumento.liquidoApagar || 0,
                            totalLetras: item.cuerpoDocumento.totalLetras || '',
                            ivaPerci1: item.cuerpoDocumento.ivaPercibido || 0,
                            ivaRete1: 0, // No esta en la version nueva creada para mantener el formato original
                            reteRenta: 0, // No esta en la version nueva creada para mantener el formato original
                            condicionOperacion: 'Cancelada', // Valor por defecto para nueva versión
                            id_account: item.id_account,
                            account_code: item.account_code,
                            account_name: item.account_description,
                            NumeroDocumentoRelacionado: numeroDocumentoRelacionado,
                        };
                        // Para la nueva versión, crear un solo gasto con toda la información
                        const expense = {
                            ...headerExpense,
                            descripcion: `${item.emisor.nombre}`,
                            precioUni: item.cuerpoDocumento.liquidoApagar || 0,
                            cantidad: 1,
                            montoDescu: 0,
                            ventaNoSuj: 0,
                            ventaExenta: 0,
                            ventaGravada: item.cuerpoDocumento.valorOperaciones || 0,
                            total: item.cuerpoDocumento.liquidoApagar || 0,
                            ItemDeclarationType: 2,
                            // Campos específicos de la nueva versión
                            comision: item.cuerpoDocumento.comision || 0,
                            ivaComision: item.cuerpoDocumento.ivaComision || 0,
                            montoSujetoPercepcion: item.cuerpoDocumento.montoSujetoPercepcion || 0,
                            montoSinPercepcion: item.cuerpoDocumento.montoSinPercepcion || 0,
                            empleadoEntrega: item.extension ? item.extension.nombEntrega : null,
                            codigoEmpleado: item.extension ? item.extension.codEmpleado : null,
                            selloRecibido: findSelloRecibido(item),
                            // Campos de clasificación para anexos
                            TipoIngresoProveedores: item.TipoIngresoProveedores || null,
                            SectorProveedores: item.SectorProveedores || null,
                            ClasificationRent: item.ClasificationRent || '2'
                        };

                        expenses.push(expense);
                    } else {
                        // Versión original - cuerpoDocumento es un array
                        // Extraer numeroDocumento de documentoRelacionado si existe
                        let numeroDocumentoRelacionado = null;
                        if (item.documentoRelacionado &&
                            Array.isArray(item.documentoRelacionado) &&
                            item.documentoRelacionado.length > 0) {
                            numeroDocumentoRelacionado = item.documentoRelacionado[0].numeroDocumento || null;
                        }

                        const processingTotals = processedDocument.totals;
                        const totalPagar = processingTotals?.totalPagar || item.resumen?.totalPagar || item.resumen?.montoTotalOperacion || 0;
                        const headerExpense = {
                            fecEmi: this.formatDate(item.identificacion.fecEmi),
                            numeroControl: item.identificacion.numeroControl,
                            codigoGeneracion: item.identificacion.codigoGeneracion,
                            documentType: 2,
                            invoiceType: item.invoiceType,
                            provider: item.provider,
                            subTotal: processingTotals?.subTotal || item.resumen?.subTotal || 0,
                            montoTotalOperacion: processingTotals?.montoTotalOperacion || item.resumen?.montoTotalOperacion || 0,
                            totalPagar: totalPagar,
                            totalLetras: item.resumen?.totalLetras || '',
                            ivaPerci1: item.resumen?.ivaPerci1 || 0,
                            ivaRete1: item.resumen?.ivaRete1 || 0,
                            reteRenta: item.resumen?.reteRenta || 0,
                            condicionOperacion: this.invoiceStatus[item.resumen?.condicionOperacion] || 'Pendiente de pago',
                            id_account: item.id_account,
                            account_code: item.account_code,
                            account_name: item.account_description,
                            NumeroDocumentoRelacionado: numeroDocumentoRelacionado,
                        };

                        // Procesar cada elemento del cuerpoDocumento
                        for (const element of processedDocument.details) {
                            // Detectar si el item tiene hidrocarburos
                            let fovialItem = 0;
                            let cotransItem = 0;
                            let isHidrocarburo = false;

                            if (element.tributos && Array.isArray(element.tributos)) {
                                const hasFovial = element.tributos.includes('D1');
                                const hasCotrans = element.tributos.includes('C8');

                                if (hasFovial || hasCotrans) {
                                    isHidrocarburo = true;
                                    if (hasFovial) {
                                        fovialItem = parseFloat((element.cantidad * 0.20).toFixed(2));
                                    }
                                    if (hasCotrans) {
                                        cotransItem = parseFloat((element.cantidad * 0.10).toFixed(2));
                                    }

                                    // Agregar columnas de FOVIAL y COTRANS si no existen
                                    if (!this.expensesHeaders.some(h => h.value === 'fovial')) {
                                        const totalPagarIndex = this.expensesHeaders.findIndex(h => h.value === 'totalPagar');
                                        this.expensesHeaders.splice(totalPagarIndex, 0, {text: 'Fovial', value: 'fovial'});
                                    }
                                    if (!this.expensesHeaders.some(h => h.value === 'cotrans')) {
                                        const totalPagarIndex = this.expensesHeaders.findIndex(h => h.value === 'totalPagar');
                                        this.expensesHeaders.splice(totalPagarIndex, 0, {text: 'Cotrans', value: 'cotrans'});
                                    }
                                }
                            }

                            const expense = {
                                ...headerExpense,
                                descripcion: element.descripcion,
                                precioUni: element.precioUni,
                                cantidad: element.cantidad,
                                montoDescu: element.montoDescu,
                                ventaNoSuj: element.ventaNoSuj,
                                ventaExenta: isFEX ? element.ventaGravada : element.ventaExenta,
                                ventaGravada: isFEX ? 0 : element.ventaGravada,
                                ItemDeclarationType: 2,
                                fovial: fovialItem,
                                cotrans: cotransItem,
                                isHidrocarburo: isHidrocarburo,
                                // Campos de clasificación para anexos
                                TipoIngresoProveedores: item.TipoIngresoProveedores || null,
                                SectorProveedores: item.SectorProveedores || null,
                                ClasificationRent: item.ClasificationRent || '2'
                            };

                            if(expense.ventaNoSuj != 0 && expense.ventaExenta == 0 && expense.ventaGravada == 0) expense.total = expense.ventaNoSuj;
                            else if(expense.ventaNoSuj == 0 && expense.ventaExenta != 0 && expense.ventaGravada == 0) expense.total = expense.ventaExenta;
                            else expense.total = expense.ventaGravada;

                            expenses.push(expense);
                        }
                    }
                }
            }
            this.expensesData = expenses;
            this.loading = false;
        },
        readFile(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (event) => resolve(event.target.result);
                reader.onerror = (error) => reject(error);
                reader.readAsText(file);
            });
        },
        async checkProvider(item) {
            try {
                const response = await this.$API.accountingexpenses.getProviderByNIT(item.nit);
                return response.data && response.data.length > 0 ? response.data[0] : null;
            } catch (error) {
                return null;
            }
        },
        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            const newDate = new Date(`${month}/${day}/${year}`)
            return this.moment(newDate).format('DD/MM/YYYY');
        },
        async addProvider(data) {
            const providerNIT = data.nit ? data.nit.toString().replaceAll("-","") : null;
            const providerNRC = data.nrc ? data.nrc.toString().replaceAll("-","") : null;

            const provider = {
                ID_Provider: null,
                ProviderName: data.nombre,
                ProviderLegalName: data.nombreComercial,
                ProviderPhone: data.telefono ? data.telefono.toString().replaceAll("-","") : null,
                ProviderContactPhone: data.telefono ? data.telefono.toString().replaceAll("-","") : null,
                ProviderContactMobile: data.telefono ? data.telefono.toString().replaceAll("-","") : null,
                ProviderContactName: data.nombre || data.nombreComercial || null,
                ProviderContactEmail: data.correo || null,
                ProviderEmail: data.correo || null,
                ProviderLegalAddress: data.direccion.complemento,
                ProviderLegalSector: data.codActividad,
                ProviderLegalTaxPayerSize: "",
                ProviderLegalEntity: "",
                ProviderLegalNRC: providerNRC,
                ProviderLegalNIT: providerNIT,
                Notes: 'Insertado autamaticamente por importación de gastos',
                ID_Business: this.id_bussiness,
                ID_Branch: this.id_branch,
                ID_User_Insert: this.id_user,
                LegalAgentRetain: data.ivaPerci1 > 0 ? 1 : 0,
            };

            return await this.$API.accountingexpenses.saveProvidersExpenses(provider)
                .then(async (response) => {
                    return response.data;
                })
                .catch(() => {
                    throw new Error('Ha ocurrido un error al insertar los proveedores, intentelo de nuevo más tarde.');
                });
        },
        async checkDuplicatedEntries(value) {
            return await this.$API.accountingexpensesentry.verifyGenerationCodes({ codigosGeneracion: value })
                .then((response) => {
                    return response?.duplicates || [];
                })
                .catch(() => {
                    return null;
                });
        },
        async getAccountsConfig() {
            try {
                const data = await this.$API.branchaccountconfig.getBranchAccountsConfig()
                this.branchAccountsConfig = data.data.config;
            } catch (error) {

                this.showAlert("danger", "Error", "Error al obtener el tipo de contabilidad");
            }
        },
        getAllAccounts() {
            this.$API.branchaccountcatalog.getActiveBranchAccountCatalog()
                .then((response) => {
                    this.accountList = response.data;
                })
                .catch(() => {
                    // Error getting accounts
                });
        },
        handleChangeAccount(e, index) {
            const found = this.accountList.find((current) => current.id_account == e.target.value);
            this.expensesData[ index ].id_account = found.id_account;
            this.expensesData[ index ].account_code = found.account_code;
            this.expensesData[ index ].account_name = found.account_description;
            this.data[ index ].id_account = found.id_account;
            this.data[ index ].account_code = found.account_code;
            this.data[ index ].account_name = found.account_description;
            this.handleBlurOnSelect();
        },
        handleBlurOnSelect() {
            this.isSelectShowed = false;
        },
        toggleSelect(index) {
            this.isSelectShowed = true;
            // Enfocar el select cuando se abre
            if (this.$nextTick) {
                this.$nextTick(() => {
                    const accountListSelect = `accountListSelect-${index}`;
                    if (this.$refs[accountListSelect]) {
                        this.$refs[accountListSelect].focus();
                    }
                });
            }
        },
        assignAllAccounts() {
            const found = this.accountList.find((current) => current.id_account == this.account.id_account);
            for (const item of this.expensesData) {
                if (found) {
                    /* item.id_account = found.id_account;
                    item.account_code = found.account_code;
                    item.account_name = found.account_description; */
                    this.$set(item, 'id_account', found.id_account);
                    this.$set(item, 'account_code', found.account_code);
                    this.$set(item, 'account_name', found.account_description);
                }
            }
            for (const item of this.data) {
                if (found) {
                    item.id_account = found.id_account;
                    item.account_code = found.account_code;
                    item.account_name = found.account_description;
                    /* this.$set(item, 'id_account', found.id_account);
                    this.$set(item, 'account_code', found.account_code);
                    this.$set(item, 'account_name', found.account_description); */
                }
            }
            this.$forceUpdate();
            this.showAlert("success", "Exito", `Se ha actualizado la tabla asignando la cuenta seleccionada a los gastos importados.`);
        },
        async processData() {
            this.loading = true;
            this.nextStep();
            this.accountingEntriesWarningMessage = "";
            try {
                if(!this.expensesData.length || !this.data.length) throw new Error('No ha seleccionado archivo con la información.');

                for (const item of this.data) {
                    const formData = new FormData();
                    const expensesEntryDetail = [];

                    if(item.toEntry === true && !item.error?.providerError) {
                        const storedProcessedDocument = item.processedDocument
                            || this.dataFiles.find(file => file === item.dteJson || file.dteJson === item.dteJson)?.processedDocument;
                        const isNewVersionDCL = this.isNewVersionJson(item.dteJson);
                        const isFEX = item.dteJson?.identificacion?.tipoDte === '11'
                            || item.invoiceType === 'FEX';
                        if (isNewVersionDCL) {
                            let numeroDocumentoRelacionado = null;
                            if (item.dteJson.documentoRelacionado &&
                                Array.isArray(item.dteJson.documentoRelacionado) &&
                                item.dteJson.documentoRelacionado.length > 0) {
                                numeroDocumentoRelacionado = item.dteJson.documentoRelacionado[0].numeroDocumento || null;
                            }

                            const expensesEntry = {
                                ID_Provider: item.provider,
                                SubTotal: item.dteJson.cuerpoDocumento.subTotal || 0,
                                TotalExpense: item.dteJson.cuerpoDocumento.liquidoApagar || 0,
                                ExpenseInvoiceDate: item.fecEmi,
                                ExpenseInvoiceType: item.invoiceType,
                                ExpenseInvoiceDocumentType: 2,
                                ExpenseInvoiceId: item.codigoGeneracion,
                                ExpenseInvoicePayment: null,
                                ExpenseInvoiceStatus: 'Pendiente de pago',
                                ExpenseInvoiceCreditDays: null,
                                ExpenseInvoiceComment: '',
                                Iva: item.dteJson.cuerpoDocumento.iva || 0,
                                Exentas: 0,
                                NoSujetas: 0,
                                ReteRenta: 0,
                                IvaRet: 0,
                                IvaPerc: item.dteJson.cuerpoDocumento.ivaPercibido || 0,
                                Descuento: item.dteJson.resumen?.descuGravada || 0,
                                ID_AccountCatalog: item.id_account,
                                CatalogName: item.account_name,
                                Fovial: 0,
                                Cotrans: 0,
                                Flete: 0,
                                Seguro: 0,
                                DteJson: item.dteJson,
                                PercentageIVA: isFEX
                                    ? null
                                    : (this.percentageIvaCheck ? this.percentageIva : null),
                                isDuplicated: item.error?.isDuplicated ? true : false,
                                CustomCSVPeriodFlag: this.CustomCSVPeriodFlag,
                                CustomCSVPeriodYear: this.CustomCSVPeriodYear,
                                CustomCSVPeriodMonth: this.CustomCSVPeriodMonth,
                                ClasificationRent: item.ClasificationRent || '2',
                                TipoIngresoProveedores: item.TipoIngresoProveedores,
                                SectorProveedores: item.SectorProveedores,
                                PaymentCondition: item.PaymentCondition || 'Contado',
                                NumeroDocumentoRelacionado: numeroDocumentoRelacionado,
                                numeroControl: item.dteJson.identificacion.numeroControl || null,
                                periodoLiquidacionFechaInicio: item.dteJson.cuerpoDocumento.periodoLiquidacionFechaInicio || null,
                                periodoLiquidacionFechaFin: item.dteJson.cuerpoDocumento.periodoLiquidacionFechaFin || null,
                                valorOperaciones: item.dteJson.cuerpoDocumento.valorOperaciones || 0,
                                codLiquidacion: item.dteJson.cuerpoDocumento.codLiquidacion || null,
                                cantidadDoc: item.dteJson.cuerpoDocumento.cantidadDoc || 1,
                                montoSujetoPercepcion: item.dteJson.cuerpoDocumento.montoSujetoPercepcion || 0,
                                ivaPercibido: item.dteJson.cuerpoDocumento.ivaPercibido || 0,
                                comision: item.dteJson.cuerpoDocumento.comision || 0,
                                porcentComision: item.dteJson.cuerpoDocumento.porcentComision || 0,
                                ivaComision: item.dteJson.cuerpoDocumento.ivaComision || 0,
                                liquidoApagar: item.dteJson.cuerpoDocumento.liquidoApagar || 0,
                                montoSinPercepcion: item.dteJson.cuerpoDocumento.montoSinPercepcion || 0,
                                EmpleadoEntrega: item.dteJson.extension ? item.dteJson.extension.nombEntrega : null,
                                CodigoEmpleado: item.dteJson.extension ? item.dteJson.extension.codEmpleado : null,
                                selloRecibido: findSelloRecibido(item.dteJson)
                            };
                            const totalDCL = item.dteJson.cuerpoDocumento.liquidoApagar || 0;
                            const subTotalDCL = item.dteJson.cuerpoDocumento.subTotal || 0;
                            const ivaDCL = item.dteJson.cuerpoDocumento.iva || 0;

                            const expensesDetails = {
                                ID: null,
                                ExpenseInvoiceId: item.codigoGeneracion,
                                NameExpense: `${item.dteJson.emisor.nombre}`,
                                UnitPrice: totalDCL,
                                Quantity: 1,
                                Total: totalDCL,
                                ID_AccountCatalog: item.id_account,
                                CatalogName: item.account_name,
                                ItemDeclarationType: item.ItemDeclarationType || 2,
                                IsNoSujeto: 0,
                                IsExento: 0,
                                IsHidrocarburo: 0,
                                NetoUnitario: parseFloat(subTotalDCL.toFixed(2)),
                                Iva: parseFloat(ivaDCL.toFixed(2)),
                                ReteRenta: 0,
                                Exentas: 0,
                                NoSujetas: 0,
                                Fovial: 0,
                                Cotrans: 0,
                                Comision: item.dteJson.cuerpoDocumento.comision || 0,
                                IvaComision: item.dteJson.cuerpoDocumento.ivaComision || 0,
                                MontoSujetoPercepcion: item.dteJson.cuerpoDocumento.montoSujetoPercepcion || 0,
                                MontoSinPercepcion: item.dteJson.cuerpoDocumento.montoSinPercepcion || 0,
                            };
                            expensesEntryDetail.push(expensesDetails);

                            formData.append("expensesEntry", JSON.stringify(expensesEntry));
                            formData.append("expensesEntryDetail", JSON.stringify(expensesEntryDetail));
                            await this.$API.accountingexpensesentry.ImportAccountingExpensesDCL(formData)
                                .then((res) => {
                                    if(res.success) {
                                        this.processed.push(item);
                                    }
                                })
                                .catch((error) => {
                                    const backendMessage = this.getBackendErrorMessage(error);
                                    item.error = {
                                        ...(item.error || {}),
                                        message: backendMessage,
                                        backendMessage,
                                    };
                                    this.notProcessed.push(item);
                                });
                            continue;
                        }
                        const processedDocument = storedProcessedDocument
                            || await this.$refs.discountDistribution.processDocument(item.dteJson);
                        const processingDetails = processedDocument.details;
                        const processingTotals = processedDocument.totals;
                        // Extraer numeroDocumento de documentoRelacionado si existe
                        let numeroDocumentoRelacionado = null;
                        if (item.dteJson && item.dteJson.documentoRelacionado &&
                            Array.isArray(item.dteJson.documentoRelacionado) &&
                            item.dteJson.documentoRelacionado.length > 0) {
                            numeroDocumentoRelacionado = item.dteJson.documentoRelacionado[0].numeroDocumento || null;
                        }

                        const expensesEntry = {
                            ID_Provider: item.provider,
                            SubTotal: processingTotals ? processingTotals.subTotal : item.subTotal,
                            TotalExpense: processingTotals ? processingTotals.totalPagar : item.totalPagar,
                            ExpenseInvoiceDate: item.fecEmi,
                            ExpenseInvoiceType: item.invoiceType,
                            ExpenseInvoiceDocumentType: 2,
                            ExpenseInvoiceId: item.codigoGeneracion,
                            ExpenseInvoiceNumeroControl: item.dteJson.identificacion.numeroControl || null,
                            ExpenseInvoicePayment: null,
                            ExpenseInvoiceStatus: (item?.dteJson?.resumen?.condicionOperacion == 2? 'Crédito' : 'Cancelada') || 'Cancelada',
                            ExpenseInvoiceCreditDays: null,
                            ExpenseInvoiceComment: '',
                            Iva: isFEX ? 0 : (processingTotals ? processingTotals.totalIva : (item.iva ? item.iva : 0)),
                            Exentas: isFEX
                                ? (processingTotals?.totalGravada ?? item.resumen?.totalGravada ?? 0)
                                : (item.resumen?.totalExenta || 0),
                            NoSujetas: item.resumen.totalNoSuj,
                            ReteRenta: item.resumen.reteRenta,
                            IvaRet: item.resumen.ivaRete1,
                            IvaPerc: item.resumen.ivaPerci1,
                            //ID_ExpenseEntry: item...,
                            ID_AccountCatalog: item.id_account,
                            CatalogName: item.account_name,
                            Fovial: item.fovial ? item.fovial : 0,
                            Cotrans: item.cotrans ? item.cotrans : 0,
                            Flete: item.flete ? item.flete : 0,
                            Seguro: item.seguro ? item.seguro : 0,
                            DteJson: processedDocument.dteJson,
                            PercentageIVA: isFEX
                                ? null
                                : (this.percentageIvaCheck ? this.percentageIva : null),
                            isDuplicated: item.error?.isDuplicated ? true : false,
                            CustomCSVPeriodFlag: this.CustomCSVPeriodFlag,
                            CustomCSVPeriodYear: this.CustomCSVPeriodYear,
                            CustomCSVPeriodMonth: this.CustomCSVPeriodMonth,
                            ClasificationRent: item.ClasificationRent || '2', // '2' = Gasto por defecto
                            TipoIngresoProveedores: item.TipoIngresoProveedores,
                            SectorProveedores: item.SectorProveedores,
                            PaymentCondition: item.PaymentCondition || 'Contado',
                            NumeroDocumentoRelacionado: numeroDocumentoRelacionado,
                            selloRecibido: findSelloRecibido(item.dteJson)
                        };


                        for (const el of processingDetails) {
                            const expensesDetails = {
                                ID: null,
                                ExpenseInvoiceId: item.codigoGeneracion,
                                NameExpense: el.descripcion,
                                UnitPrice: processingTotals
                                    ? parseFloat((Number(el.ventaNoSuj || el.ventaExenta || el.ventaGravada || 0) / (Number(el.cantidad) || 1)).toFixed(2))
                                    : el.precioUni,
                                Quantity: el.cantidad,
                                ID_AccountCatalog: el.id_account ? el.id_account : item.id_account,
                                CatalogName: el.account_name ? el.account_name : item.account_name,
                                ItemDeclarationType: item.ItemDeclarationType
                            }

                            if (isFEX) {
                                const totalFEX = parseFloat(el.ventaGravada || 0);
                                expensesDetails.Total = 0;
                                expensesDetails.NetoUnitario = totalFEX;
                                expensesDetails.Iva = 0;
                                expensesDetails.Exentas = totalFEX;
                                expensesDetails.NoSujetas = 0;
                                expensesDetails.IsExento = 1;
                                expensesDetails.IsNoSujeto = 0;
                            }
                            else if(el.ventaNoSuj != 0 && el.ventaExenta == 0 && el.ventaGravada == 0) {
                                expensesDetails.Total = el.ventaNoSuj;
                                expensesDetails.IsNoSujeto = 1;
                            }
                            else if(el.ventaNoSuj == 0 && el.ventaExenta != 0 && el.ventaGravada == 0) {
                                expensesDetails.Total = el.ventaExenta;
                                expensesDetails.IsExento = 1;
                            }
                            else expensesDetails.Total = el.ventaGravada;

                            expensesEntryDetail.push(expensesDetails);
                        }

                        formData.append("expensesEntry", JSON.stringify(expensesEntry));
                        formData.append("expensesEntryDetail", JSON.stringify(expensesEntryDetail));
                        await this.$API.accountingexpensesentry.ImportAccountingExpenses(formData)
                            .then((res) => {
                                if(res.success) {
                                    this.processed.push(item);
                                }
                            })
                            .catch((error) => {
                                const backendMessage = this.getBackendErrorMessage(error);
                                item.error = {
                                    ...(item.error || {}),
                                    message: backendMessage,
                                    backendMessage,
                                };
                                this.notProcessed.push(item);
                                //this.processError = true;
                                //throw new Error();
                            });
                    }
                    else {
                        this.notProcessed.push(item);
                    }
                }

                // Crear partidas contables después del procesamiento exitoso
                if (this.processed.length > 0 && this.accountingEntriesPreview.length > 0) {
                    await this.createAccountingEntries();
                }

                this.loading = false;

                let finalTitle = "Gastos contables importados";
                let finalType = "success";
                let finalBody = "Los gastos importados fueron agregados correctamente y se crearon las partidas contables correspondientes.";

                if(this.data.length == this.notProcessed.length) {
                    finalType = "warning";
                    finalBody = "Los gastos importados no pudieron procesarse debido a la existencia de errores.";
                }
                else if(this.data.length != this.processed.length) {
                    finalType = "warning";
                    finalBody = "Algunos gastos importados no pudieron procesarse debido a la existencia de errores.";
                }

                if (this.accountingEntriesWarningMessage) {
                    finalBody = `${finalBody}\n\n${this.accountingEntriesWarningMessage}`;
                    finalType = "dangerStrong";
                    this.accountingEntriesWarningMessage = "";
                }

                this.showAlert(finalType, finalTitle, finalBody);
            }
            catch (error) {
                this.loading = false;
                this.processError = true;
                this.showAlert("danger", "Error", this.getBackendErrorMessage(error));
            }
        },
        exportToExcel(value) {
            if(value === 'ERROR') {
                const headers = this.tableHeaders.map(header => header.text);
                const data = this.productsNotAllowed.map(item => this.tableHeaders.map(header => item[header.value]));

                const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data]);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Plantilla inventario');

                XLSX.writeFile(workbook, 'plantilla_inventario_errores.xlsx');

            } else if(value === 'SUCCESS') {
                const headers = this.expensesHeaders.map(header => header.text);
                const data = this.processed.map(item => this.expensesHeaders.map(header => item[header.value]));

                const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data]);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Gastos importados');

                XLSX.writeFile(workbook, 'Gastos_importados.xlsx');

            }
        },
        switchEntryData(item) {
            if(!item) return;

            // No permitir cambiar el estado SOLO si falta selloRecibido requerido
            if(item.error && item.error.selloRecibidoRequired) {
                return;
            }

            for (const element of this.dataFiles) {
                if(element.identificacion.numeroControl == item.numeroControl && element.identificacion.codigoGeneracion == item.codigoGeneracion) {
                    element.toEntry = !element.toEntry;
                }
            }
        },
        switchSelectAll() {
            for (const item of this.data) {
                // No cambiar el estado SOLO si falta selloRecibido requerido
                if(!item.error || !item.error.selloRecibidoRequired) {
                    item.toEntry = this.selectAll;
                }
            }
            for (const item of this.dataFiles) {
                // No cambiar el estado SOLO si falta selloRecibido requerido
                if(!item.error || !item.error.selloRecibidoRequired) {
                    item.toEntry = this.selectAll;
                }
            }
        },
        deleteFile(file) {
            this.data.filter((item) => item.numeroControl != file.numeroControl && item.codigoGeneracion != file.codigoGeneracion);
            this.dataFiles.filter((item) => item.identificacion.numeroControl != file.numeroControl && item.identificacion.codigoGeneracion != file.codigoGeneracion);
        },
        onClickProcess() {
            this.showAlert("question2", "Advertencia", "¿Esta seguro que desea continuar?", "processData");
        },
        showAlert(type, header, body, options = null) {
            type = type == null ? "danger" : type;
            this.alert.type = type;
            this.alert.header = header;
            this.alert.body = body;
            this.alert.show = true;
            this.alert.options = options != null ? options : null;
        },
        closeAlert() {
            this.alert.show = false;
            if (this.alert.options == 'duplicateDocuments') {
                this.duplicateDocuments = [];
                this.loading = false;
            }
            if (this.alert.options == 'continueStep') {
                this.nextStep();
            }
            this.alert.options = null;
        },
        cloneEntryValue(value) {
            if (value === null || value === undefined) {
                return null;
            }

            try {
                return JSON.parse(JSON.stringify(value));
            } catch (error) {
                return null;
            }
        },
        parseStoredExpenseJson(value) {
            if (!value) {
                return null;
            }

            if (typeof value === 'object') {
                return this.cloneEntryValue(value);
            }

            try {
                return JSON.parse(value);
            } catch (error) {
                return null;
            }
        },
        parseStoredAmount(value) {
            const parsed = parseFloat(value);
            return Number.isFinite(parsed) ? parsed : 0;
        },
        formatStoredDateForDte(date) {
            if (!date) {
                return null;
            }

            const parts = String(date).split('/');
            if (parts.length === 3) {
                return `${parts[2]}-${parts[1]}-${parts[0]}`;
            }

            return date;
        },
        formatStoredDateForGrid(date) {
            if (!date) {
                return null;
            }

            if (String(date).includes('/')) {
                return date;
            }

            return this.formatDate(date);
        },
        normalizeStoredInvoiceType(type) {
            return String(type || '')
                .toUpperCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/[^A-Z0-9]/g, '');
        },
        getDteCodeFromStoredInvoiceType(type) {
            const normalized = this.normalizeStoredInvoiceType(type);
            const types = {
                FCF: '01',
                CCF: '03',
                NC: '05',
                ND: '06',
                FEX: '11',
                FNS: '14'
            };

            return types[normalized] || null;
        },
        getStoredInvoiceTypeFromDteCode(type) {
            const types = {
                '01': 'FCF',
                '03': 'CCF',
                '05': 'NC',
                '06': 'ND',
                '11': 'FEX',
                '14': 'FNS'
            };

            return types[type] || null;
        },
        isPurchaseIvaTributo(tributo) {
            const description = this.normalizeStoredInvoiceType(tributo?.descripcion);
            return String(tributo?.codigo || '') === '20' || description === 'IVA';
        },
        buildStoredExpenseTributos(expense, dteJson) {
            const isFinalConsumer = this.isFinalConsumerExpense({
                ...expense,
                identificacion: dteJson?.identificacion
            });

            if (Array.isArray(dteJson?.resumen?.tributos) && dteJson.resumen.tributos.length > 0) {
                const tributos = this.cloneEntryValue(dteJson.resumen.tributos);
                return isFinalConsumer
                    ? tributos.filter(tributo => !this.isPurchaseIvaTributo(tributo))
                    : tributos;
            }

            const tributos = [];
            const iva = this.parseStoredAmount(expense.Iva);
            const cotrans = this.parseStoredAmount(expense.Cotrans);
            const fovial = this.parseStoredAmount(expense.Fovial);

            if (!isFinalConsumer && iva > 0) {
                tributos.push({ codigo: '20', descripcion: 'IVA', valor: iva });
            }
            if (cotrans > 0) {
                tributos.push({ codigo: 'C8', descripcion: 'COTRANS', valor: cotrans });
            }
            if (fovial > 0) {
                tributos.push({ codigo: 'D1', descripcion: 'FOVIAL', valor: fovial });
            }

            return tributos;
        },
        buildStoredExpenseCuerpoDocumento(details) {
            return (Array.isArray(details) ? details : []).map(detail => {
                const total = this.parseStoredAmount(detail.Total);

                return {
                    descripcion: detail.NameExpense,
                    precioUni: this.parseStoredAmount(detail.UnitPrice),
                    cantidad: this.parseStoredAmount(detail.Quantity),
                    ventaNoSuj: detail.IsNoSujeto ? total : 0,
                    ventaExenta: detail.IsExento ? total : 0,
                    ventaGravada: !detail.IsNoSujeto && !detail.IsExento ? total : 0,
                    montoDescu: 0,
                    id_account: detail.ID_AccountCatalog,
                    account_name: detail.CatalogName
                };
            });
        },
        resolveStoredPaymentCondition(expense, dteJson) {
            const explicitCondition = expense?.PaymentCondition;
            if (explicitCondition === 'Contado' || explicitCondition === 'Crédito') {
                return explicitCondition;
            }

            const invoiceStatus = expense?.ExpenseInvoiceStatus || dteJson?.resumen?.condicionOperacion;
            if (invoiceStatus === 'Crédito' || invoiceStatus === 'Pendiente de pago') {
                return 'Crédito';
            }

            return 'Contado';
        },
        buildStoredExpenseForAccounting() {
            const expense = this.cloneEntryValue(this.storedExpense) || {};
            const details = this.cloneEntryValue(this.storedExpenseDetails) || [];
            const dteJson = this.parseStoredExpenseJson(expense.DteJson) || {};
            const paymentCondition = this.resolveStoredPaymentCondition(expense, dteJson);

            const codigoGeneracion = expense.ExpenseInvoiceId || dteJson?.identificacion?.codigoGeneracion || '';
            const numeroControl = expense.ExpenseInvoiceNumeroControl || dteJson?.identificacion?.numeroControl || codigoGeneracion;
            const tipoDte = dteJson?.identificacion?.tipoDte || this.getDteCodeFromStoredInvoiceType(expense.ExpenseInvoiceType);
            const invoiceType = expense.ExpenseInvoiceType || this.getStoredInvoiceTypeFromDteCode(tipoDte);
            const fecEmi = dteJson?.identificacion?.fecEmi || this.formatStoredDateForDte(expense.ExpenseInvoiceDate);
            const providerName = expense.ProviderName || dteJson?.emisor?.nombre || '';
            const totalPagar = this.parseStoredAmount(expense.TotalExpense || dteJson?.resumen?.totalPagar || dteJson?.resumen?.montoTotalOperacion);
            const totalGravada = this.parseStoredAmount(dteJson?.resumen?.totalGravada ?? expense.SubTotal);
            const subTotal = this.parseStoredAmount(expense.SubTotal || dteJson?.resumen?.subTotal || totalGravada);
            const tributos = this.buildStoredExpenseTributos(expense, dteJson);

            const accountingExpense = {
                ...expense,
                toEntry: true,
                provider: expense.ID_Provider,
                id_account: expense.ID_AccountCatalog || null,
                account_name: expense.CatalogName || null,
                identificacion: {
                    ...(this.cloneEntryValue(dteJson?.identificacion) || {}),
                    fecEmi,
                    numeroControl,
                    codigoGeneracion,
                    tipoDte
                },
                emisor: {
                    ...(this.cloneEntryValue(dteJson?.emisor) || {}),
                    nombre: providerName,
                    nombreComercial: dteJson?.emisor?.nombreComercial || expense.ProviderLegalName || providerName,
                    nit: dteJson?.emisor?.nit || expense.ProviderLegalNIT || '',
                    nrc: dteJson?.emisor?.nrc || expense.ProviderLegalNRC || ''
                },
                resumen: {
                    ...(this.cloneEntryValue(dteJson?.resumen) || {}),
                    subTotal,
                    totalGravada,
                    totalExenta: this.parseStoredAmount(expense.Exentas || dteJson?.resumen?.totalExenta),
                    totalNoSuj: this.parseStoredAmount(expense.NoSujetas || dteJson?.resumen?.totalNoSuj),
                    totalNoGravado: this.parseStoredAmount(dteJson?.resumen?.totalNoGravado),
                    montoTotalOperacion: this.parseStoredAmount(dteJson?.resumen?.montoTotalOperacion || totalPagar),
                    totalPagar,
                    ivaRete1: this.parseStoredAmount(expense.IvaRet || dteJson?.resumen?.ivaRete1),
                    ivaPerci1: this.parseStoredAmount(expense.IvaPerc || dteJson?.resumen?.ivaPerci1),
                    reteRenta: this.parseStoredAmount(expense.ReteRenta || dteJson?.resumen?.reteRenta),
                    totalIva: this.parseStoredAmount(expense.Iva || dteJson?.resumen?.totalIva),
                    tributos
                },
                cuerpoDocumento: Array.isArray(dteJson?.cuerpoDocumento) && dteJson.cuerpoDocumento.length > 0
                    ? this.cloneEntryValue(dteJson.cuerpoDocumento)
                    : this.buildStoredExpenseCuerpoDocumento(details)
            };

            const row = {
                ...accountingExpense,
                ivaRete1: accountingExpense.resumen.ivaRete1,
                ivaPerci1: accountingExpense.resumen.ivaPerci1,
                totalIva: accountingExpense.resumen.totalIva,
                reteRenta: accountingExpense.resumen.reteRenta,
                descuNoSuj: accountingExpense.resumen.descuNoSuj,
                descuExenta: accountingExpense.resumen.descuExenta,
                descuGravada: accountingExpense.resumen.descuGravada,
                porcentajeDescuento: accountingExpense.resumen.porcentajeDescuento,
                totalDescu: accountingExpense.resumen.totalDescu,
                totalNoSuj: accountingExpense.resumen.totalNoSuj,
                totalExenta: accountingExpense.resumen.totalExenta,
                totalGravada: accountingExpense.resumen.totalGravada,
                totalNoGravado: accountingExpense.resumen.totalNoGravado,
                subTotalVentas: accountingExpense.resumen.subTotalVentas,
                fecEmi: this.formatStoredDateForGrid(fecEmi),
                numeroControl,
                codigoGeneracion,
                invoiceType,
                provider: accountingExpense.provider,
                nit: accountingExpense.emisor.nit,
                nrc: accountingExpense.emisor.nrc,
                nombre: providerName,
                nombreComercial: accountingExpense.emisor.nombreComercial,
                subTotal,
                montoTotalOperacion: accountingExpense.resumen.montoTotalOperacion,
                totalPagar,
                toEntry: true,
                error: null,
                dteJson: accountingExpense,
                ItemDeclarationType: 2,
                TipoIngresoProveedores: expense.TipoIngresoProveedores || null,
                SectorProveedores: expense.SectorProveedores || null,
                ClasificationRent: expense.ClasificationRent || '2',
                PaymentCondition: paymentCondition
            };

            tributos.forEach(tributo => {
                if (this.isPurchaseIvaTributo(tributo)) {
                    row.iva = tributo.valor;
                }
                if (tributo.codigo === 'D1') {
                    row.fovial = tributo.valor;
                }
                if (tributo.codigo === 'C8') {
                    row.cotrans = tributo.valor;
                }
            });

            return { accountingExpense, row };
        },
        initializeStoredExpenseMode() {
            const { accountingExpense, row } = this.buildStoredExpenseForAccounting();

            this.id_branch = this.storedExpense?.ID_Branch || this.id_branch;
            this.step = 2;
            this.dataLoaded = true;
            this.selectedFiles = [];
            this.selectedFilesNames = [];
            this.dataFiles = [accountingExpense];
            this.data = [row];
            this.processed = [row];
            this.notProcessed = [];
            this.showProcessed = false;
            this.showNotProcessed = false;
            this.globalClasificationRent = row.ClasificationRent;
            this.globalPaymentCondition = row.PaymentCondition;
            this.globalSectorProveedores = row.SectorProveedores;
            this.globalTipoIngresoProveedores = row.TipoIngresoProveedores;
        },
        async createStoredExpenseAccountingEntry() {
            if (!this.entryOnlyMode) {
                return;
            }

            if (!this.accountingEntryConfig.concept || !this.accountingEntryConfig.type) {
                this.showAlert("warning", "Advertencia", "Debe completar la configuración de partidas contables.");
                return;
            }

            this.loading = true;
            this.accountingEntriesWarningMessage = "";
            try {
                await this.generateAccountingEntriesPreview();

                if (this.accountingEntriesPreview.length === 0) {
                    this.showAlert("warning", "Advertencia", "No se pudieron generar las partidas contables. Verifique la configuración.");
                    return;
                }

                const nameValidation = this.validateAccountingEntryNames();
                if (!nameValidation.valid) {
                    this.showAlert("warning", "Items sin nombre", nameValidation.message);
                    return;
                }

                this.processed = this.data.filter(item => item.toEntry);
                const result = await this.createAccountingEntries();
                if (!result) {
                    this.showAlert("warning", "Advertencia", "No se pudo crear la partida contable.");
                    return;
                }

                this.$emit('created', {
                    id_accounting_entry: result?.id_accounting_entry,
                    ID_Accounting_item: result?.ID_Accounting_item
                });

                if (this.accountingEntriesWarningMessage) {
                    this.showAlert("dangerStrong", "Advertencia", this.accountingEntriesWarningMessage);
                    this.accountingEntriesWarningMessage = "";
                }
            } catch (error) {
                const conflict = error?.response?.status === 409 || error?.response?.data?.status === 409;
                if (conflict) {
                    const data = error.response.data;
                    this.$emit('created', {
                        duplicate: true,
                        id_accounting_entry: data.id_accounting_entry,
                        ID_Accounting_item: data.ID_Accounting_item
                    });
                    return;
                }

                this.showAlert("danger", "Error", this.getBackendErrorMessage(error));
            } finally {
                this.loading = false;
            }
        },
        acceptAlert() {
            this.alert.show = false;
            if (this.alert.options == 'duplicateDocuments') {
                this.continueWithAllDuplicates();
                this.alert.options = null;
                return;
            }
            if (this.alert.options == 'processData') {
                this.processData();
            }
            if (this.alert.options == 'continueStep') {
                this.nextStep();
            }
            this.alert.options = null;
        },
        secondaryAlert() {
            this.alert.show = false;
            if (this.alert.options == 'duplicateDocuments') {
                this.continueWithoutDuplicates();
            }
            this.alert.options = null;
        },
        continueWithoutDuplicates() {
            const duplicatedCodes = new Set(
                (this.duplicateDocuments || [])
                    .map(item => this.normalizeGenerationCode(item?.codigoGeneracion))
                    .filter(Boolean)
            );

            this.dataFiles = this.dataFiles.filter(item => {
                const code = this.normalizeGenerationCode(item?.identificacion?.codigoGeneracion);
                return !duplicatedCodes.has(code);
            });

            this.duplicateDocuments = [];
            this.loading = false;

            if (this.dataFiles.length === 0) {
                this.showAlert(
                    "warning",
                    "Advertencia",
                    "No quedan documentos para procesar después de excluir los duplicados."
                );
                return;
            }

            this.handleFilesUpload();
        },
        continueWithAllDuplicates() {
            this.loading = false;
            this.handleFilesUpload();
        },
        showError(message) {
            this.showAlert("warning", "Advertencia", message);
        },
        getBackendErrorMessage(error) {
            return error?.response?.data?.message
                || error?.response?.data?.error
                || error?.message
                || "Ocurrio un error en el procesamiento de la información.";
        },
        resetData() {
            this.dataLoaded = false;
            this.selectAll = true;
            this.selectedFiles = [];
            this.selectedFilesNames = [];
            this.dataFiles = [];
            this.data = [];
            this.expensesData = [];
            this.errors = null;
            this.processError = false;
            this.percentageIvaCheck = true;
            this.percentageIva = 100;
            this.globalPaymentCondition = null;
            this.selectedAccountConfiguration = null;
            this.providersNeedingConfiguration = [];
            this.providerAccountsData = [];
            this.dclCommissionAccountSource = 'provider';
            this.dclReceivableAccountSource = 'provider';

            // Limpiar datos de partidas contables
            this.accountingEntriesPreview = [];
            this.accountingEntryConfig = {
                concept: "",
                type: null,
                nameType: "numeroControl"
            };
            this.customItemNames = {};
            this.accountingEntryDate = moment().format("DD/MM/YYYY");
            this.createdAccountingEntryData = null;
            this.globalTipoIngresoProveedores = null;
            this.globalSectorProveedores = null;
            this.globalClasificationRent = null;
            this.duplicateDocuments = [];
            this.invalidJsonFiles = [];  // Limpiar archivos inválidos
        },
        resetAll() {
            this.step = 1;
            this.loading = false;
            this.dataLoaded = false;
            this.selectAll = true;
            this.selectedFiles = [];
            this.selectedFilesNames = [];
            this.dataFiles = [];
            this.data = [];
            this.expensesData = [];
            this.errors = null;
            this.processError = false;
            this.processed = [];
            this.notProcessed = [];
            this.showNotProcessed = false;
            this.showProcessed = false;
            this.account = {
                id_account: null
            };
            this.percentageIvaCheck = true;
            this.percentageIva = 100;
            this.globalPaymentCondition = null;
            this.selectedAccountConfiguration = null;
            this.providersNeedingConfiguration = [];
            this.providerAccountsData = [];
            this.dclCommissionAccountSource = 'provider';
            this.dclReceivableAccountSource = 'provider';

            // Limpiar datos de partidas contables
            this.accountingEntriesPreview = [];
            this.accountingEntryConfig = {
                concept: "",
                type: null,
                nameType: "numeroControl"
            };
            this.customItemNames = {};
            this.accountingEntryDate = moment().format("DD/MM/YYYY");
            this.createdAccountingEntryData = null;

            this.globalTipoIngresoProveedores = null;
            this.globalSectorProveedores = null;
            this.globalClasificationRent = null;
            this.duplicateDocuments = [];
            this.invalidJsonFiles = [];  // Limpiar archivos inválidos

            this.cleanState = true;
        },

        // Métodos para partidas contables
        changeAccountingDate(date) {
            this.accountingEntryDate = date;
            this.getLastAcountingCorrelative();
        },

        updateCustomItemName(item, newValue) {
            // Crear un ID único para el item basado en su información
            const itemKey = this.generateItemKey(item);
            this.$set(this.customItemNames, itemKey, newValue);

            // Actualizar directamente el concepto en el item sin regenerar toda la vista previa
            this.$set(item, 'concept', newValue);
        },

        generateItemKey(item) {
            // Generar una clave única para identificar cada item
            // Usamos account_code + Deb + Hab para crear una clave única
            return `${item.account_code}_${item.Deb}_${item.Hab}_${item.Comentario || ''}`.replace(/[^a-zA-Z0-9_]/g, '_');
        },

        getCustomItemName(item) {
            const itemKey = this.generateItemKey(item);
            return this.customItemNames[itemKey] || '';
        },

        validateAccountingEntryNames() {
            // Solo validar si nameType es 'empty'
            if (this.accountingEntryConfig.nameType !== 'empty') {
                return { valid: true, message: '' };
            }

            // Verificar que todos los items en la vista previa tengan nombres
            let emptyItems = [];

            if (this.accountingEntriesPreview.length > 0) {
                this.accountingEntriesPreview.forEach((entry, entryIndex) => {
                    entry.details.forEach((item, itemIndex) => {
                        const itemName = item.concept || '';
                        if (!itemName.trim()) {
                            emptyItems.push({
                                entryIndex: entryIndex + 1,
                                itemIndex: itemIndex + 1,
                                account: item.account_code || 'Sin cuenta',
                                description: item.account_description || 'Sin descripción'
                            });
                        }
                    });
                });
            }

            if (emptyItems.length > 0) {
                const itemList = emptyItems.map(item =>
                    `- Partida ${item.entryIndex}, Item ${item.itemIndex} (${item.account} - ${item.description})`
                ).join('\n');

                return {
                    valid: false,
                    message: `Los siguientes items no tienen nombre asignado:\n\n${itemList}\n\nPor favor, asigne un nombre a todos los items antes de continuar.`
                };
            }

            return { valid: true, message: '' };
        },

        generateAccountingEntryItemName(expense, entryType = 'gasto', itemData = null) {
            // entryType puede ser: 'gasto', 'iva', 'pago'
            const nameType = this.accountingEntryConfig.nameType;
            const codigoGeneracion = this.getExpenseGenerationCode(expense);
            const numeroControl = this.getExpenseControlNumber(expense);
            
            switch (nameType) {
                case 'empty':
                    // Si tenemos datos del item, obtener su nombre personalizado
                    if (itemData) {
                        return this.getCustomItemName(itemData);
                    }
                    return '';

                case 'codigoGeneracion':
                    if (entryType === 'gasto' || entryType === 'iva' || entryType === 'pago' || entryType === 'cotrans' || entryType === 'fovial') {
                        return codigoGeneracion;
                    }
                    return codigoGeneracion;
                    
                case 'numeroControl':
                    if (entryType === 'gasto' || entryType === 'iva' || entryType === 'pago' || entryType === 'cotrans' || entryType === 'fovial') {
                        return numeroControl;
                    }
                    return numeroControl;
                    
                case 'concept':
                    return this.accountingEntryConfig.concept || '';

                default:
                    // Por defecto mantener la lógica actual (numeroControl)
                    if (entryType === 'gasto' || entryType === 'iva' || entryType === 'pago' || entryType === 'cotrans' || entryType === 'fovial') {
                        return numeroControl;
                    }
                    return numeroControl;
            }
        },

        getExpenseGenerationCode(expense) {
            return String(
                expense?.identificacion?.codigoGeneracion ||
                expense?.codigoGeneracion ||
                expense?.ExpenseInvoiceId ||
                ''
            );
        },

        getExpenseControlNumber(expense) {
            return String(
                expense?.identificacion?.numeroControl ||
                expense?.numeroControl ||
                expense?.ExpenseInvoiceNumeroControl ||
                expense?.ExpenseInvoiceId ||
                ''
            );
        },

        isCreditNoteExpense(expense) {
            return expense?.identificacion?.tipoDte === '05';
        },

        isFinalConsumerExpense(expense) {
            const tipoDte = String(expense?.identificacion?.tipoDte || expense?.tipoDte || '');
            const invoiceType = this.normalizeStoredInvoiceType(
                expense?.invoiceType ||
                expense?.ExpenseInvoiceType ||
                expense?.InvoiceType ||
                expense?.tipoFactura ||
                ''
            );

            return tipoDte === '01' || invoiceType === '01' || invoiceType === 'FCF' || invoiceType === 'FAF' || invoiceType.includes('CONSUMIDORFINAL');
        },

        isExportExpense(expense) {
            const tipoDte = String(
                expense?.identificacion?.tipoDte ||
                expense?.dteJson?.identificacion?.tipoDte ||
                expense?.tipoDte ||
                ''
            );
            const invoiceType = this.normalizeStoredInvoiceType(
                expense?.invoiceType ||
                expense?.ExpenseInvoiceType ||
                expense?.InvoiceType ||
                expense?.tipoFactura ||
                ''
            );

            return tipoDte === '11' || invoiceType === '11' || invoiceType === 'FEX' || invoiceType === 'FE';
        },

        shouldGeneratePurchaseIva(expense) {
            return !this.isExportExpense(expense) && !this.isFinalConsumerExpense(expense);
        },

        getExpensePurchaseIvaAmount(expense) {
            const ivaTributo = Array.isArray(expense?.resumen?.tributos)
                ? expense.resumen.tributos.find(tributo => this.isPurchaseIvaTributo(tributo))
                : null;

            return this.parseStoredAmount(expense?.resumen?.totalIva || ivaTributo?.valor);
        },

        getExpensePurchaseBaseAmount(expense) {
            const totalGravada = this.parseStoredAmount(expense?.resumen?.totalGravada) - this.parseStoredAmount(expense?.resumen?.descuGravada ?? 0);
            const totalNoSuj = (this.parseStoredAmount(expense?.resumen?.totalNoSuj) || 0) - this.parseStoredAmount(expense?.resumen?.descuNoSuj ?? 0);
            const totalNoGravado = this.parseStoredAmount(expense?.resumen?.totalNoGravado) || 0;
            const totalExenta = (this.parseStoredAmount(expense?.resumen?.totalExenta) || 0) - this.parseStoredAmount(expense?.resumen?.descuExenta ?? 0);
            const total = totalGravada + totalNoSuj + totalNoGravado + totalExenta;
            if (!this.isFinalConsumerExpense(expense)) {
                return total;
            }

            const ivaAmount = this.getExpensePurchaseIvaAmount(expense);
            const totalWithIva = totalGravada + ivaAmount;
            const operationTotal = this.parseStoredAmount(expense?.resumen?.montoTotalOperacion || expense?.resumen?.totalPagar);

            if (ivaAmount > 0 && operationTotal > 0 && Math.abs(operationTotal - totalWithIva) < 0.02) {
                return operationTotal;
            }

            if (ivaAmount > 0 && (operationTotal <= 0 || totalWithIva <= operationTotal + 0.02)) {
                return totalWithIva;
            }

            return totalGravada;
        },

        expenseNeedsPurchaseIvaAccount(expense) {
            if (!this.shouldGeneratePurchaseIva(expense)) {
                return false;
            }

            const ivaTributo = Array.isArray(expense?.resumen?.tributos)
                ? expense.resumen.tributos.find(tributo => this.isPurchaseIvaTributo(tributo))
                : null;

            if (ivaTributo && parseFloat(ivaTributo.valor || 0) > 0) {
                return true;
            }

            return parseFloat(expense?.resumen?.totalGravada || 0) > 0;
        },
        isDclExpense(expense) {
            return expense?.invoiceType === 'DCL'
                || expense?.identificacion?.tipoDte === '09'
                || expense?.dteJson?.identificacion?.tipoDte === '09';
        },
        findAccountById(accountId) {
            if (accountId === null || accountId === undefined || accountId === '') {
                return null;
            }

            return this.accountList.find(acc => acc.id_account != null && acc.id_account.toString() === accountId.toString()) || null;
        },
        getDclConfiguredAccount(provider, providerField, generalField, source) {
            const accountId = source === 'general'
                ? this.branchAccountsConfig?.[generalField]
                : provider?.[providerField];

            return this.findAccountById(accountId);
        },

        getAccountingAmounts(amount, normalSide = 'debit', expense = null) {
            const formattedAmount = parseFloat(amount || 0).toFixed(2);
            const isDnc = this.isCreditNoteExpense(expense);

            if (normalSide === 'credit') {
                return isDnc
                    ? { Deb: formattedAmount, Hab: "0.00" }
                    : { Deb: "0.00", Hab: formattedAmount };
            }

            return isDnc
                ? { Deb: "0.00", Hab: formattedAmount }
                : { Deb: formattedAmount, Hab: "0.00" };
        },

        debouncedGeneratePreview() {
            // Solo generar vista previa si estamos en el paso 4 y tenemos datos
            if (this.step !== 4 || this.dataFiles.length === 0) {
                return;
            }

            // Evitar regenerar si ya existe una vista previa y solo se están editando nombres personalizados
            if (this.accountingEntriesPreview.length > 0 && this.accountingEntryConfig.nameType === 'empty') {
                return;
            }

            // Limpiar timer anterior
            if (this.previewGenerationTimer) {
                clearTimeout(this.previewGenerationTimer);
            }

            // Establecer nuevo timer
            this.previewGenerationTimer = setTimeout(() => {
                this.generateAccountingEntriesPreview();
            }, 500);
        },

        async generateAccountingEntriesPreview(showAlert = false) {
            this.loading = true;
            try {
                this.accountingEntriesPreview = [];

                // Crear una sola partida contable que contenga todos los gastos
                const entry = await this.createSingleAccountingEntryForAllExpenses();
                if (entry) {
                    this.accountingEntriesPreview.push(entry);
                }

                // Solo mostrar alerta si se solicita explícitamente
                if (showAlert) {
                    this.showAlert("success", "Vista previa generada", 
                        `Se ha generado 1 partida contable con ${this.dataFiles.filter(item => item.toEntry).length} gasto(s)`);
                }

            } catch (error) {
                if (showAlert) {
                    this.showAlert("danger", "Error", "Error al generar la vista previa de partidas contables");
                }
            } finally {
                this.loading = false;
            }
        },

        async createSingleAccountingEntryForAllExpenses() {
            try {
                const details = [];
                const expenses = this.dataFiles.filter(item => item.toEntry);
                
                if (expenses.length === 0) {
                    return null;
                }

                // Obtener cuentas de configuración general
                const accountIva = this.accountList.find(acc => acc.id_account != null && acc.id_account.toString() === this.branchAccountsConfig?.purchase_iva_id_account?.toString());
                const accountIvaPerception = this.accountList.find( acc => acc.id_account != null && acc.id_account.toString() === this.branchAccountsConfig?.purchases_perceptions_id_account?.toString() );
                const accountIvaWithHoldings = this.accountList.find( acc => acc.id_account != null && acc.id_account.toString() === this.branchAccountsConfig?.purchases_withholdings_id_account?.toString() );
                const accountRentHoldings = this.accountList.find( acc => acc.id_account != null && acc.id_account.toString() === this.branchAccountsConfig?.provisions_rent_holdings_id_account?.toString() );
                const accountCotrans = this.accountList.find( acc => acc.id_account != null && acc.id_account.toString() === this.branchAccountsConfig?.purchases_cotrans_hidrocarbons_id_account?.toString() );
                const accountFovial = this.accountList.find( acc => acc.id_account != null && acc.id_account.toString() === this.branchAccountsConfig?.purchases_fovial_hidrocarbons_id_account?.toString() );
                const accountDclIvaPerception = this.hasDclDocuments
                    ? this.findAccountById(this.branchAccountsConfig?.sd_AnticipoCuentaIVA2Percent)
                    : null;
                const accountDclCommission = this.hasDclDocuments && this.dclCommissionAccountSource === 'general'
                    ? this.findAccountById(this.branchAccountsConfig?.sd_GastoComision)
                    : null;
                const accountDclReceivable = this.hasDclDocuments && this.dclReceivableAccountSource === 'general'
                    ? this.findAccountById(this.branchAccountsConfig?.sd_CuentasPorCobrar)
                    : null;

                // console.log( 'accountIva ', accountIva )
                // console.log( 'accountIvaPerception ', accountIvaPerception )
                // console.log( 'accountIvaWithHoldings ', accountIvaWithHoldings )
                // console.log( 'accountRentHoldings ', accountRentHoldings )
                // console.log( 'accountCotrans ', accountCotrans )
                // console.log( 'accountFovial ', accountFovial )
                // console.log( 'accountDclIvaPerception ', accountDclIvaPerception )
                // console.log( 'accountDclCommission ', accountDclCommission )
                // console.log( 'accountDclReceivable ', accountDclReceivable )

                let unnasignedAccounts = 0;
                let unnasignedAccountsLabel = '';

                const needsPurchaseIvaAccount = expenses.some(expense => this.expenseNeedsPurchaseIvaAccount(expense));

                if( needsPurchaseIvaAccount && !accountIva ) {
                    unnasignedAccounts += 1;
                    unnasignedAccountsLabel += '- La cuenta de "CRÉDITO FISCAL" de "Provisiones" no ha sido asignada<br/>'
                }

                if( !accountIvaPerception ) {
                    unnasignedAccounts += 1;
                    unnasignedAccountsLabel += '- La cuenta de "PERCEPCIÓN IVA" de "Provisiones" no ha sido asignada<br/>'
                }

                if( this.hasDclDocuments && !accountDclIvaPerception ) {
                    unnasignedAccounts += 1;
                    unnasignedAccountsLabel += '- La cuenta de "Cuenta para Anticipo a Cuenta IVA 2%" de "Parametrización General" no ha sido asignada<br/>'
                }

                if( !accountIvaWithHoldings ) {
                    unnasignedAccounts += 1;
                    unnasignedAccountsLabel += '- La cuenta de "RETENCIÓN IVA" de "Provisiones" no ha sido asignada<br/>'
                }

                if( !accountRentHoldings ) {
                    unnasignedAccounts += 1;
                    unnasignedAccountsLabel += '- La cuenta de "RETENCIÓN RENTA" de "Provisiones" no ha sido asignada<br/>'
                }

                if( !accountCotrans ) {
                    unnasignedAccounts += 1;
                    unnasignedAccountsLabel += '- La cuenta de "COTRANS" de "Provisiones" no ha sido asignada<br/>'
                }

                if( this.hasDclDocuments && this.dclCommissionAccountSource === 'general' && !accountDclCommission ) {
                    unnasignedAccounts += 1;
                    unnasignedAccountsLabel += '- La cuenta de "Cuenta de Gasto por Comisiones" de "Parametrización General" no ha sido asignada<br/>'
                }

                if( this.hasDclDocuments && this.dclReceivableAccountSource === 'general' && !accountDclReceivable ) {
                    unnasignedAccounts += 1;
                    unnasignedAccountsLabel += '- La cuenta de "Cuenta General de Cuentas por Cobrar" de "Parametrización General" no ha sido asignada<br/>'
                }

                if( !accountFovial ) {
                    unnasignedAccounts += 1;
                    unnasignedAccountsLabel += '- La cuenta de "FOVIAL" de "Provisiones" no ha sido asignada<br/>'
                }


                if( unnasignedAccounts > 0 ) {
                    throw new Error( JSON.stringify( { code: 'UNASSIGNED_ACCOUNTS_GEN_PARAMS', message: unnasignedAccountsLabel } ) );
                }
                // Procesar cada gasto y agregar sus detalles
                for (const expense of expenses) {
                    const expenseGenerationCode = this.getExpenseGenerationCode(expense);
                    const expenseControlNumber = this.getExpenseControlNumber(expense);
                    const expenseComment = `${expense.emisor.nombre} - ${expenseControlNumber}`;
                    // Obtener la clasificación individual del item desde this.data
                    const dataItem = this.data.find(d => d.codigoGeneracion === expenseGenerationCode);
                    const expenseClasification = dataItem ? dataItem.ClasificationRent : '2'; // '2' = Gasto por defecto

                    const provider = this.providerAccountsData.find(
                        p => p.ID_Provider === expense.provider
                    );

                    if (this.isDclExpense(expense)) {
                        const cuerpoDocumento = expense.cuerpoDocumento || expense.dteJson?.cuerpoDocumento || {};
                        const dclLiquidoApagar = parseFloat(cuerpoDocumento.liquidoApagar || 0);
                        const dclIvaPercibido = parseFloat(cuerpoDocumento.ivaPercibido || 0);
                        const dclComision = parseFloat(cuerpoDocumento.comision || 0);
                        const dclIvaComision = parseFloat(cuerpoDocumento.IVAcomision || cuerpoDocumento.ivaComision || 0);
                        const dclValorOperaciones = parseFloat(cuerpoDocumento.valorOperaciones || 0);
                        const cuentaDclBanco = this.findAccountById(provider?.CuentaBanco_ID);
                        const cuentaDclComision = this.getDclConfiguredAccount(provider, 'GastoComision_ID', 'sd_GastoComision', this.dclCommissionAccountSource);
                        const cuentaDclReceivable = this.getDclConfiguredAccount(provider, 'CuentasPorCobrar_ID', 'sd_CuentasPorCobrar', this.dclReceivableAccountSource);

                        if (dclLiquidoApagar > 0) {
                            const liquidoApagarDetail = {
                                account_code: cuentaDclBanco ? cuentaDclBanco.account_code : 'Sin cuenta',
                                account_description: cuentaDclBanco ? cuentaDclBanco.account_description : 'No configurada',
                                id_account: cuentaDclBanco ? cuentaDclBanco.id_account : null,
                                Comentario: `${expense.emisor.nombre} - ${expense.identificacion.numeroControl}`,
                                ...this.getAccountingAmounts(dclLiquidoApagar, 'debit', expense),
                                concept: this.generateAccountingEntryItemName(expense, 'gasto')
                            };

                            if (this.accountingEntryConfig.nameType === 'empty') {
                                const customName = this.getCustomItemName(liquidoApagarDetail);
                                liquidoApagarDetail.concept = customName;
                            }

                            details.push(liquidoApagarDetail);
                        }

                        if (dclIvaPercibido > 0) {
                            const ivaPercibidoDetail = {
                                account_code: accountDclIvaPerception.account_code,
                                account_description: accountDclIvaPerception.account_description,
                                id_account: accountDclIvaPerception.id_account,
                                Comentario: `${expense.emisor.nombre} - ${expense.identificacion.numeroControl}`,
                                ...this.getAccountingAmounts(dclIvaPercibido, 'debit', expense),
                                concept: this.generateAccountingEntryItemName(expense, 'gasto')
                            };

                            if (this.accountingEntryConfig.nameType === 'empty') {
                                const customName = this.getCustomItemName(ivaPercibidoDetail);
                                ivaPercibidoDetail.concept = customName;
                            }

                            details.push(ivaPercibidoDetail);
                        }

                        if (dclComision > 0) {
                            const comisionDetail = {
                                account_code: cuentaDclComision ? cuentaDclComision.account_code : 'Sin cuenta',
                                account_description: cuentaDclComision ? cuentaDclComision.account_description : 'No configurada',
                                id_account: cuentaDclComision ? cuentaDclComision.id_account : null,
                                Comentario: `${expense.emisor.nombre} - ${expense.identificacion.numeroControl}`,
                                ...this.getAccountingAmounts(dclComision, 'debit', expense),
                                concept: this.generateAccountingEntryItemName(expense, 'gasto')
                            };

                            if (this.accountingEntryConfig.nameType === 'empty') {
                                const customName = this.getCustomItemName(comisionDetail);
                                comisionDetail.concept = customName;
                            }

                            details.push(comisionDetail);
                        }

                        if (dclIvaComision > 0) {
                            const ivaComisionDetail = {
                                account_code: accountIva.account_code,
                                account_description: accountIva.account_description,
                                id_account: accountIva.id_account,
                                Comentario: `${expense.emisor.nombre} - ${expense.identificacion.numeroControl}`,
                                ...this.getAccountingAmounts(dclIvaComision, 'debit', expense),
                                concept: this.generateAccountingEntryItemName(expense, 'gasto')
                            };

                            if (this.accountingEntryConfig.nameType === 'empty') {
                                const customName = this.getCustomItemName(ivaComisionDetail);
                                ivaComisionDetail.concept = customName;
                            }

                            details.push(ivaComisionDetail);
                        }

                        if (dclValorOperaciones > 0) {
                            const valorOperacionesDetail = {
                                account_code: cuentaDclReceivable ? cuentaDclReceivable.account_code : 'Sin cuenta',
                                account_description: cuentaDclReceivable ? cuentaDclReceivable.account_description : 'No configurada',
                                id_account: cuentaDclReceivable ? cuentaDclReceivable.id_account : null,
                                Comentario: `${expense.emisor.nombre} - ${expense.identificacion.numeroControl}`,
                                ...this.getAccountingAmounts(dclValorOperaciones, 'credit', expense),
                                concept: this.generateAccountingEntryItemName(expense, 'gasto')
                            };

                            if (this.accountingEntryConfig.nameType === 'empty') {
                                const customName = this.getCustomItemName(valorOperacionesDetail);
                                valorOperacionesDetail.concept = customName;
                            }

                            details.push(valorOperacionesDetail);
                        }

                        continue;
                    }

                    // Obtener cuentas del proveedor
                    const cuentaBanco = this.accountList.find(acc => acc.id_account != null && acc.id_account.toString() === (provider?.CuentaBanco_ID != null ? provider.CuentaBanco_ID.toString() : ''));
                    const cuentaCuentasPorPagar = this.accountList.find(acc => acc.id_account != null && acc.id_account.toString() === (provider?.CuentaCuentasPorPagar_ID != null ? provider.CuentaCuentasPorPagar_ID.toString() : ''));
                    const cuentaGastos = this.accountList.find(acc => acc.id_account != null && acc.id_account.toString() === (provider?.CuentaGastos_ID != null ? provider.CuentaGastos_ID.toString() : ''));
                    const cuentaCostos = this.accountList.find(acc => acc.id_account != null && acc.id_account.toString() === (provider?.CuentaCostos_ID != null ? provider.CuentaCostos_ID.toString() : ''));

                    // Usar la clasificación individual del gasto
                    const cuentaGastoCobro = expenseClasification === "2" ? cuentaGastos : cuentaCostos;
                    const shouldGenerateIva = this.shouldGeneratePurchaseIva(expense);
                    
                    // Agregar detalle para cuenta de gasto/costo (DEBE)

                    // Si el gasto tiene IVA, agregar cuenta de IVA
                    if( expense.resumen.tributos && expense.resumen.tributos.length > 0 && accountCotrans ) {
                        const cotransTributo = expense.resumen.tributos.find( tributo => tributo.codigo === "C8" );
                        const cotransValor = cotransTributo ? parseFloat( cotransTributo.valor ) : 0;

                        if( cotransValor > 0 ) {
                            const cotransDetail = {
                                account_code: accountCotrans.account_code,
                                account_description: accountCotrans.account_description,
                                id_account: accountCotrans.id_account,
                                Comentario: expenseComment,
                                ...this.getAccountingAmounts(cotransValor, 'debit', expense),
                                concept: this.generateAccountingEntryItemName(expense, 'cotrans')
                            }

                            // Si nameType es 'empty', actualizar con nombre personalizado si existe
                            if (this.accountingEntryConfig.nameType === 'empty') {
                                const customName = this.getCustomItemName(cotransDetail);
                                cotransDetail.concept = customName;
                            }

                            details.push( cotransDetail );
                        }
                    }

                    if( expense.resumen.tributos && expense.resumen.tributos.length > 0 && accountFovial ) {
                        const fovialTributo = expense.resumen.tributos.find( tributo => tributo.codigo === "D1" );
                        const fovialValor = fovialTributo ? parseFloat( fovialTributo.valor ) : 0;

                        if( fovialValor > 0 ) {
                            const fovialDetail = {
                                account_code: accountFovial.account_code,
                                account_description: accountFovial.account_description,
                                id_account: accountFovial.id_account,
                                Comentario: expenseComment,
                                ...this.getAccountingAmounts(fovialValor, 'debit', expense),
                                concept: this.generateAccountingEntryItemName(expense, 'fovial')
                            }

                            // Si nameType es 'empty', actualizar con nombre personalizado si existe
                            if (this.accountingEntryConfig.nameType === 'empty') {
                                const customName = this.getCustomItemName(fovialDetail);
                                fovialDetail.concept = customName;
                            }

                            details.push( fovialDetail );
                        }
                    }

                    if (shouldGenerateIva && expense.resumen.tributos && expense.resumen.tributos.length > 0 && accountIva) {
                        const ivaTributo = expense.resumen.tributos.find(tributo => this.isPurchaseIvaTributo(tributo));
                        const ivaValor = ivaTributo ? parseFloat(ivaTributo.valor) : 0;

                        if (ivaValor > 0) {
                            const ivaDetail = {
                                account_code: accountIva.account_code,
                                account_description: accountIva.account_description,
                                id_account: accountIva.id_account,
                                Comentario: expenseComment,
                                ...this.getAccountingAmounts(ivaValor, 'debit', expense),
                                concept: this.generateAccountingEntryItemName(expense, 'iva')
                            };

                            // Si nameType es 'empty', actualizar con nombre personalizado si existe
                            if (this.accountingEntryConfig.nameType === 'empty') {
                                const customName = this.getCustomItemName(ivaDetail);
                                ivaDetail.concept = customName;
                            }

                            details.push(ivaDetail);
                        }
                    } else if(
                        shouldGenerateIva &&
                        (
                            !expense.resumen.tributos ||
                            (
                                expense.resumen.tributos &&
                                expense.resumen.tributos.find(tributo => this.isPurchaseIvaTributo(tributo)) === undefined
                            )
                        ) &&
                        accountIva &&
                        parseFloat( expense.resumen.totalGravada ) > 0
                    ) {
                        const ivaValor = parseFloat( expense.resumen.totalGravada ) * 0.13;

                        if( ivaValor > 0 ) {
                            const ivaDetail = {
                                account_code: accountIva.account_code,
                                account_description: accountIva.account_description,
                                id_account: accountIva.id_account,
                                Comentario: expenseComment,
                                ...this.getAccountingAmounts(ivaValor, 'debit', expense),
                                concept: this.generateAccountingEntryItemName(expense, 'iva')
                            }

                            // Si nameType es 'empty', actualizar con nombre personalizado si existe
                            if (this.accountingEntryConfig.nameType === 'empty') {
                                const customName = this.getCustomItemName(ivaDetail);
                                ivaDetail.concept = customName;
                            }

                            details.push(ivaDetail);

                            expense.resumen.totalGravada -= ivaValor;
                        }
                    }
                    // Calculo de gastos
                    const gastoTotal = this.getExpensePurchaseBaseAmount(expense) -
                            parseFloat( expense.resumen?.ivaRete1 ? expense.resumen.ivaRete1: 0 );


                    const gastoDetail = {
                        account_code: cuentaGastoCobro ? cuentaGastoCobro.account_code : 'Sin cuenta',
                        account_description: cuentaGastoCobro ? cuentaGastoCobro.account_description : 'No configurada',
                        id_account: cuentaGastoCobro ? cuentaGastoCobro.id_account : null,
                        Comentario: expenseComment,
                        ...this.getAccountingAmounts((
                            gastoTotal
                        ), 'debit', expense),
                        concept: this.generateAccountingEntryItemName(expense, 'gasto')
                    };

                    //console.log( 'expense.resumen ', expense.resumen );

                    // Si nameType es 'empty', actualizar con nombre personalizado si existe
                    if (this.accountingEntryConfig.nameType === 'empty') {
                        const customName = this.getCustomItemName(gastoDetail);
                        gastoDetail.concept = customName;
                    }

                    details.push(gastoDetail);

                    if( expense.resumen.ivaRete1 && parseFloat( expense.resumen.ivaRete1 ) > 0 && accountIvaWithHoldings ) {
                        const valor = parseFloat( expense.resumen.ivaRete1 );

                        if( valor > 0 ) {
                            const ivaWithHoldingsDetail = {
                                account_code: accountIvaWithHoldings.account_code,
                                account_description: accountIvaWithHoldings.account_description,
                                id_account: accountIvaWithHoldings.id_account,
                                Comentario: expenseComment,
                                ...this.getAccountingAmounts(valor, 'debit', expense),
                                concept: this.generateAccountingEntryItemName( expense )
                            };

                            // Si nameType es 'empty', actualizar con nombre personalizado si existe
                            if (this.accountingEntryConfig.nameType === 'empty') {
                                const customName = this.getCustomItemName(ivaWithHoldingsDetail);
                                ivaWithHoldingsDetail.concept = customName;
                            }

                            details.push(ivaWithHoldingsDetail);
                        }
                    }

                    if( expense.resumen.ivaPerci1 && parseFloat( expense.resumen.ivaPerci1 ) > 0 && accountIvaPerception ) {
                        const valor = parseFloat( expense.resumen.ivaPerci1 );

                        if( valor > 0 ) {
                            const ivaPerceptionsDetail = {
                                account_code: accountIvaPerception.account_code,
                                account_description: accountIvaPerception.account_description,
                                id_account: accountIvaPerception.id_account,
                                Comentario: expenseComment,
                                ...this.getAccountingAmounts(valor, 'debit', expense),
                                concept: this.generateAccountingEntryItemName( expense )
                            };

                            // Si nameType es 'empty', actualizar con nombre personalizado si existe
                            if (this.accountingEntryConfig.nameType === 'empty') {
                                const customName = this.getCustomItemName(ivaPerceptionsDetail);
                                ivaPerceptionsDetail.concept = customName;
                            }

                            details.push(ivaPerceptionsDetail);
                        }
                    }


                    if( expense.resumen.reteRenta && parseFloat( expense.resumen.reteRenta ) > 0 && accountRentHoldings ) {
                        const valor = parseFloat( expense.resumen.reteRenta );

                        if( valor > 0 ) {
                            const rentHoldingsDetail = {
                                account_code: accountRentHoldings.account_code,
                                account_description: accountRentHoldings.account_description,
                                id_account: accountRentHoldings.id_account,
                                Comentario: expenseComment,
                                ...this.getAccountingAmounts(valor, 'credit', expense),
                                concept: this.generateAccountingEntryItemName( expense )
                            };

                            // Si nameType es 'empty', actualizar con nombre personalizado si existe
                            if (this.accountingEntryConfig.nameType === 'empty') {
                                const customName = this.getCustomItemName(rentHoldingsDetail);
                                rentHoldingsDetail.concept = customName;
                            }

                            details.push(rentHoldingsDetail);
                        }
                    }
                    // Agregar detalle para cuenta de pago (HABER)
                    const _dataItemPago = this.data.find(d => d.codigoGeneracion === expenseGenerationCode);
                    const _expensePayment = _dataItemPago ? (_dataItemPago.PaymentCondition || 'Contado') : 'Contado';
                    const cuentaContadoCredito = _expensePayment === 'Contado' ? cuentaBanco : cuentaCuentasPorPagar;
                    const totalPagoDetail = (
                            parseFloat( expense.resumen.totalPagar || expense.resumen.montoTotalOperacion || 0 ) +
                            parseFloat( expense.resumen?.ivaRete1 ? expense.resumen.ivaRete1: 0 )
                        )
                    const pagoDetail = {
                        account_code: cuentaContadoCredito ? cuentaContadoCredito.account_code : 'Sin cuenta',
                        account_description: cuentaContadoCredito ? cuentaContadoCredito.account_description : 'No configurada',
                        id_account: cuentaContadoCredito ? cuentaContadoCredito.id_account : null,
                        Comentario: expenseComment,
                        ...this.getAccountingAmounts(totalPagoDetail, 'credit', expense),
                        concept: this.generateAccountingEntryItemName(expense, 'pago')
                    };

                    // Si nameType es 'empty', actualizar con nombre personalizado si existe
                    if (this.accountingEntryConfig.nameType === 'empty') {
                        const customName = this.getCustomItemName(pagoDetail);
                        pagoDetail.concept = customName;
                    }

                    details.push(pagoDetail);
                }

                // Calcular totales sumando los valores de todas las partidas
                const totalDebe = details.reduce((sum, detail) => sum + parseFloat(detail.Deb || 0), 0);
                const totalHaber = details.reduce((sum, detail) => sum + parseFloat(detail.Hab || 0), 0);

                // Crear concepto general que incluya el número de gastos
                const conceptoGeneral = `${this.accountingEntryConfig.concept}`;
                return {
                    concept: conceptoGeneral,
                    date: this.accountingEntryDate,
                    type: this.accountingEntryConfig.type,
                    details: details,
                    totalDebe: totalDebe,
                    totalHaber: totalHaber,
                    relatedExpenses: expenses // Array de todos los gastos relacionados
                };

            } catch (error) {
                try {
                    const errorJson = JSON.parse( error.message );

                    if( errorJson.code === 'UNASSIGNED_ACCOUNTS_GEN_PARAMS' ) {
                        this.showAlert(
                            'dangerHtml',
                            'Cuentas sin Asignar',
                            `Antes de continuar asigne las siguientes cuentas en el módulo de "Contabilidad->Asignación de Cuentas->Parametrización General":<br/><br/>${ errorJson.message }`
                        );
                    } else {
                        throw error;
                    }
                } catch (error) {
                    this.showAlert(
                        'danger',
                        "Error creando partida única para gastos:",
                        error.message
                    );
                    return null;
                    
                } 

            }
        },

        async createAccountingEntryForExpense(expense) {
            try {
                const details = [];
                const expenseGenerationCode = this.getExpenseGenerationCode(expense);
                const expenseControlNumber = this.getExpenseControlNumber(expense);
                const expenseComment = `${expense.emisor.nombre} - ${expenseControlNumber}`;


                const provider = this.providerAccountsData.find(
                    p => p.ID_Provider === expense.provider
                );



                // Convertir ambos a string para comparar correctamente
                const cuentaBanco = this.accountList.find(acc => acc.id_account != null && acc.id_account.toString() === (provider?.CuentaBanco_ID != null ? provider.CuentaBanco_ID.toString() : ''));
                const cuentaCuentasPorPagar = this.accountList.find(acc => acc.id_account != null && acc.id_account.toString() === (provider?.CuentaCuentasPorPagar_ID != null ? provider.CuentaCuentasPorPagar_ID.toString() : ''));
                const cuentaGastos = this.accountList.find(acc => acc.id_account != null && acc.id_account.toString() === (provider?.CuentaGastos_ID != null ? provider.CuentaGastos_ID.toString() : ''));
                const cuentaCostos = this.accountList.find(acc => acc.id_account != null && acc.id_account.toString() === (provider?.CuentaCostos_ID != null ? provider.CuentaCostos_ID.toString() : ''));
                const accountIva = this.accountList.find(acc => acc.id_account != null && acc.id_account.toString() === this.branchAccountsConfig?.purchase_iva_id_account?.toString());
                const shouldGenerateIva = this.shouldGeneratePurchaseIva(expense);

                // Obtener la clasificación individual del gasto desde this.data
                const dataItem = this.data.find(d => d.codigoGeneracion === expenseGenerationCode);
                const expenseClasification = dataItem ? dataItem.ClasificationRent : '2'; // '2' = Gasto por defecto

                const cuentaGastoCobro = expenseClasification === "2" ? cuentaGastos : cuentaCostos;

                // Crear detalle para cuenta de gasto/costo (DEBE)
                const gastoDetail = {
                    account_code: cuentaGastoCobro ? cuentaGastoCobro.account_code : 'Sin cuenta',
                    account_description: cuentaGastoCobro ? cuentaGastoCobro.account_description : 'No configurada',
                    id_account: cuentaGastoCobro ? cuentaGastoCobro.id_account : null,
                    Comentario: expenseComment,
                    ...this.getAccountingAmounts(this.getExpensePurchaseBaseAmount(expense), 'debit', expense),
                    concept: this.generateAccountingEntryItemName(expense, 'gasto')
                };

                // Si nameType es 'empty', actualizar con nombre personalizado si existe
                if (this.accountingEntryConfig.nameType === 'empty') {
                    const customName = this.getCustomItemName(gastoDetail);
                    gastoDetail.concept = customName;
                }

                details.push(gastoDetail);

                // Si el gasto tiene IVA, agregar cuenta de IVA
                if (shouldGenerateIva && expense.resumen.tributos && expense.resumen.tributos.length > 0 && accountIva) {
                    // Buscar el tributo de IVA (código "20")
                    const ivaTributo = expense.resumen.tributos.find(tributo => this.isPurchaseIvaTributo(tributo));
                    const ivaValor = ivaTributo ? parseFloat(ivaTributo.valor) : 0;

                    if (ivaValor > 0) {
                        const ivaDetail = {
                            account_code: accountIva.account_code,
                            account_description: accountIva.account_description,
                            id_account: accountIva.id_account,
                            Comentario: expenseComment,
                            ...this.getAccountingAmounts(ivaValor, 'debit', expense),
                            concept: this.generateAccountingEntryItemName(expense, 'iva')
                        };

                        // Si nameType es 'empty', actualizar con nombre personalizado si existe
                        if (this.accountingEntryConfig.nameType === 'empty') {
                            const customName = this.getCustomItemName(ivaDetail);
                            ivaDetail.concept = customName;
                        }

                        details.push(ivaDetail);
                    }
                }

                // Crear detalle para cuenta de pago (HABER)
                const _dataItemSingle = this.data.find(d => d.codigoGeneracion === expenseGenerationCode);
                const _singlePayment = _dataItemSingle ? (_dataItemSingle.PaymentCondition || 'Contado') : 'Contado';
                const cuentaContadoCredito = _singlePayment === 'Contado' ? cuentaBanco : cuentaCuentasPorPagar;

                const pagoDetail = {
                    account_code: cuentaContadoCredito ? cuentaContadoCredito.account_code : 'Sin cuenta',
                    account_description: cuentaContadoCredito ? cuentaContadoCredito.account_description : 'No configurada',
                    id_account: cuentaContadoCredito ? cuentaContadoCredito.id_account : null,
                    Comentario: expenseComment,
                    ...this.getAccountingAmounts(expense.resumen.totalPagar || 0, 'credit', expense),
                    concept: this.generateAccountingEntryItemName(expense, 'pago')
                };

                // Si nameType es 'empty', actualizar con nombre personalizado si existe
                if (this.accountingEntryConfig.nameType === 'empty') {
                    const customName = this.getCustomItemName(pagoDetail);
                    pagoDetail.concept = customName;
                }

                details.push(pagoDetail);

                // Calcular totales sumando los valores de las partidas
                const totalDebe = details.reduce((sum, detail) => sum + parseFloat(detail.Deb || 0), 0);
                const totalHaber = details.reduce((sum, detail) => sum + parseFloat(detail.Hab || 0), 0);

                return {
                    concept: `${this.accountingEntryConfig.concept} - ${expense.emisor.nombre}`,
                    date: this.accountingEntryDate,
                    type: this.accountingEntryConfig.type,
                    details: details,
                    totalDebe: totalDebe,
                    totalHaber: totalHaber,
                    relatedExpense: expense
                };

            } catch (error) {
                console.error("Error creando partida para gasto:", error);
                return null;
            }
        },

        getAccountsForExpense(expense) {
            // Obtener la cuenta de gasto/costo del proveedor
            let expenseAccount = null;
            if (expense.id_account) {
                expenseAccount = this.accountList.find(acc => acc.id_account === expense.id_account);
            }

            // Obtener la cuenta de pago según la configuración
            let paymentAccount = null;

            // Buscar el proveedor para obtener sus cuentas configuradas
            const provider = this.providerAccountsData.find(p => p.ID_Provider === expense.provider);

            if (provider && provider.providerDetails) {
                // Convertir ambos a string para comparar correctamente
                const cuentaBanco = provider.providerDetails.CuentaBanco != null ? provider.providerDetails.CuentaBanco.toString() : null;
                const cuentaCuentasPorPagar = provider.providerDetails.CuentaCuentasPorPagar != null ? provider.providerDetails.CuentaCuentasPorPagar.toString() : null;

                const _dataItemPay = this.data.find(d => d.provider === expense.provider && d.codigoGeneracion === expense.codigoGeneracion);
                const _expPay = _dataItemPay ? (_dataItemPay.PaymentCondition || 'Contado') : 'Contado';
                if (_expPay === 'Contado' && cuentaBanco) {
                    paymentAccount = this.accountList.find(acc => acc.id_account != null && acc.id_account.toString() === cuentaBanco);
                } else if (_expPay === 'Crédito' && cuentaCuentasPorPagar) {
                    paymentAccount = this.accountList.find(acc => acc.id_account != null && acc.id_account.toString() === cuentaCuentasPorPagar);
                }
            }

            return {
                expenseAccount: expenseAccount,
                paymentAccount: paymentAccount
            };
        },

        async createAccountingEntries() {
            // Como ahora solo hay una partida contable que contiene todos los gastos
            if (this.accountingEntriesPreview.length > 0) {
                const singleEntry = this.accountingEntriesPreview[0];
                return await this.saveAccountingEntry(singleEntry);
            }

            return null;
        },

        async saveAccountingEntry(entryData) {
            // Preparar datos según el formato usado en AccountingItem.vue
            const { concept, type } = entryData;
            const accountingEntryDate = this.accountingEntryDate;

            // Remover elementos vacíos de la lista
            const cleanDetails = entryData.details.filter(detail => detail.id_account);

            if (cleanDetails.length === 0) {
                throw new Error('No hay detalles válidos para la partida contable');
            }

            // Validar que las sumas cuadren
            let totalDebe = cleanDetails.reduce((sum, detail) => sum + parseFloat(detail.Deb || 0), 0);
            let totalHaber = cleanDetails.reduce((sum, detail) => sum + parseFloat(detail.Hab || 0), 0);
            const difference = Math.abs(totalDebe - totalHaber);

            if (difference > 0) { // Tolerance for rounding errors
                const sideToAdjust = totalDebe > totalHaber ? "haber" : "debe";
                this.accountingEntriesWarningMessage = `La partida presenta una diferencia de ${difference.toFixed(2)} por redondeo. Debe realizar un ajuste manual en el ${sideToAdjust} luego de crearla.`;
            }

            // Preparar los detalles para la API
            for (const detail of cleanDetails) {
                detail.Deb = parseFloat(detail.Deb).toFixed(2);
                detail.Hab = parseFloat(detail.Hab).toFixed(2);

                // Validar que no tenga valores en debe y haber al mismo tiempo
                if (parseFloat(detail.Deb) > 0 && parseFloat(detail.Hab) > 0) {
                    throw new Error(`El detalle de cuenta ${detail.account_code} no puede tener valor en debe y haber`);
                }

                if (parseFloat(detail.Deb) === 0 && parseFloat(detail.Hab) === 0) {
                    throw new Error(`El detalle de cuenta ${detail.account_code} debe tener un valor en debe o haber`);
                }
            }

            // Generar el correlativo automáticamente
            await this.getLastAcountingCorrelative();
            const correlativo = this.generateNextCorrelative();

            // Crear la partida contable
            const result = await this.$API.accountingentryheader.createAccountingEntryHeader({
                accountingentry: {
                    accounting_entry_comment: concept,
                    accounting_entry_date: this.convertDateFormat(accountingEntryDate),
                    id_accounting_entry_type: type,
                    accounting_entry_value: Math.max(totalDebe, totalHaber).toFixed(2), // Agregar el valor total de la partida
                    ID_Accounting_item: correlativo, // Agregar el correlativo generado
                    accountingentrydetails: cleanDetails.map(detail => ({
                        id_account: detail.id_account,
                        id_entry_detail_type: detail.Hab > 0 ? 1 : 2,
                        concept: detail.concept,
                        amount: detail.Hab > 0 ? detail.Hab : detail.Deb,
                        id_accounting_entry_detail_type: detail.Hab > 0 ? 'Haber' : 'Debe'
                    }))
                },
                related_expenses:
                    this.processed.map(item =>
                        (
                            {
                                DocumentInvoiceId: item.codigoGeneracion,
                                DocumentType: item.ClasificationRent
                            }
                        )
                    ) // Enviar la lista de gastos relacionados
            });

            // Actualizar el último correlativo para futuros usos
            this.lastAccountingCorrelative = correlativo;

            // Obtener la información completa de la partida contable recién creada
            try {
                const accountingHeaderInfo = await this.$API.accountlevel.getAcountingHeaderByAccountingItem({
                    id_accounting_item: correlativo
                });

                // Guardar la información de la partida para uso posterior
                if (accountingHeaderInfo && accountingHeaderInfo.data) {
                    this.createdAccountingEntryData = accountingHeaderInfo.data;
                }
            } catch (error) {
                console.warn('Error al obtener información de la partida contable:', error);
                // No lanzar error aquí ya que la partida se creó exitosamente
            }

            return {
                ...result,
                ID_Accounting_item: correlativo
            };
        },

        convertDateFormat(dateString) {
            // Convertir de DD/MM/YYYY a formato aceptado por la API
            const parts = dateString.split('/');
            if (parts.length === 3) {
                return `${parts[2]}-${parts[1]}-${parts[0]}`;
            }
            return dateString;
        },

        async getAcounteringType() {
            try {
                const response = await this.$API.branchaccountcatalog.getAcounteringType();
                this.TypesItems = response.data;

                // Establecer tipo por defecto si está vacío
                if (!this.accountingEntryConfig.type && this.TypesItems.length > 0) {
                    this.accountingEntryConfig.type = this.TypesItems[0].id_accounting_entry_type;
                }
            } catch (error) {
                // Error getting accounting types
            }
        },

        async getLastAcountingCorrelative() {
            try {
                const selectedDate = moment(this.accountingEntryDate, 'DD/MM/YYYY', true);
                const dateToFind = selectedDate.isValid() ? selectedDate : moment();
                const result = await this.$API.accountlevel.getLastAcountingCorrelative({
                    monthToFind: dateToFind.month() + 1,
                    yearToFind: dateToFind.year()
                });
                this.lastAccountingCorrelative = result.data?.ID_Accounting_item || '';
            } catch (error) {
                // Se ignora porque este dato no bloquea la creación de la partida.
            }
        },

        getCorrelative(value) {
            let newVal = value.toString();
            if(newVal.length < 6) {
                for(let i = newVal.length; i < 6; i++) {
                    newVal = '0' + newVal;
                }
            }
            const selectedDate = moment(this.accountingEntryDate, 'DD/MM/YYYY', true);
            const dateToUse = selectedDate.isValid() ? selectedDate : moment();
            return `PC${dateToUse.format('YYYYMM') + newVal}`;
        },

        generateNextCorrelative() {
            // Extraer el número del último correlativo o usar 0 si no existe
            let nextNumber = 1;
            if (this.lastAccountingCorrelative) {
                // Extraer solo los últimos 6 dígitos del correlativo
                const match = this.lastAccountingCorrelative.match(/(\d{6})$/);
                if (match) {
                    nextNumber = parseInt(match[1]) + 1;
                }
            }
            return this.getCorrelative(nextNumber);
        },

        async goToModifyAccountingEntry() {
            if (!this.createdAccountingEntryData) {
                this.showAlert("warning", "Advertencia", "No se encontró información de la partida contable creada");
                return;
            }

            try {
                // Preparar los datos para enviar al componente de modificación
                const dataToSend = {
                    ...this.createdAccountingEntryData,
                    // Agregar cualquier información adicional necesaria
                    correlativo: this.lastAccountingCorrelative
                };


                // Abrir la ventana de modificación de partida contable
                this.$store.dispatch('addWindow', {
                    name: 'Acounting',
                    component: 'Acounting',
                    unique: false,
                    meta: { accountingEntryToModify: dataToSend[0], initEditable: true }
                });

                // Opcional: mostrar mensaje de confirmación
                this.showAlert("success", "Navegación", "Se abrió la ventana para modificar la partida contable");

            } catch (error) {
                console.error('Error al abrir ventana de modificación:', error);
                this.showAlert("danger", "Error", "Error al abrir la ventana de modificación de partida contable");
            }
        },
    }
};
</script>

<style scoped>
.card-step {
    min-height: 400px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 2rem;
}
.col-input-file {
    display: flex;
    flex-direction: row;
    gap: 20px;
    padding: 1rem;
}
.btn-import {
  background-color: #3498db !important;
  color: white;
  min-width: 250px !important;
  height: 40px !important;
}
.btnoption {
  background-color: #3498DB !important;
  color: white;
}
.btncontinue {
  background-color: rgba(80, 80, 80, 1) !important;
  color: white;
}
.btndisable {
    background-color: #41464c !important;
    color: white;
}
.entry-only-advanced {
    max-height: calc(100vh - 64px);
    min-height: 0 !important;
    overflow-y: auto;
}
.entry-only-advanced .v-stepper {
    min-height: 0 !important;
}
</style>

<style>
.accounting-entry-dialog {
    margin: 24px !important;
    max-height: calc(100vh - 48px) !important;
    overflow: hidden !important;
}
.accounting-entry-dialog > .rounded-lg {
    max-height: calc(100vh - 48px);
    min-height: 0 !important;
    overflow-y: auto;
}
.mdi-file-excel::before {
    font-size: 32px !important;
}
.data-table .v-data-table__wrapper thead th {
    height: 35px !important;
    text-wrap: nowrap;
    min-width: 100px;
}
.data-table .v-data-table__wrapper tbody tr {
    height: 35px !important;
}
.data-table .v-data-table__wrapper tbody td {
    height: 35px !important;
    padding: 8px 16px;
}
.file-table .v-data-table__wrapper thead th {
    height: 5px !important;
    text-wrap: nowrap;
    min-width: 100px;
    border: 0px !important;
}
.file-table .v-data-table__wrapper tbody tr {
    height: 35px !important;
    text-wrap: nowrap;
    min-width: 100px;
    border: 0px !important;
}
.file-table .v-data-table__wrapper tbody td.text-start {
    padding: 0px;
    border: 0px !important;
}
.file-table .v-data-table__wrapper tbody td {
    height: 35px !important;
    text-wrap: nowrap;
    min-width: 100px;
    border: 0px !important;
}
.tabs-seg .v-slide-group__content {
    justify-content: space-between;
}
.check .v-input__control {
    flex-direction: row !important;
    flex-wrap: nowrap !important;
}

</style>
